<template>

  <div id="post-immo">
    <el-dialog
        :title="$t('posts.dialog.selectModelTitle')"
        :visible.sync="modalShowModels"
        width="30%"
        v-loading="loadingCMIcreatePost"
        :element-loading-text="$t('portals.list.chargementDonnees')"
    >
      <el-row :gutter="25">
        <el-col :span="tailleSelectPopup">
          <el-form-item v-if="selectTerrainCmisteModele == true && listeTerrains" :label="labelModeleTerrain">
            <el-select v-model="currentLandId"
                       :placeholder="$t('posts.dialog.selectListTerrain')"
                       @change="checkModelCmisteButton"
                       v-if="listeTerrains !== null"
                       filterable
                       clearable>
              <el-option
                  v-for="terrain in listeTerrains.list"
                  :key="terrain.id"
                  :label="terrain.reference + ' - ' + terrain.titre"
                  :value="terrain.id"
              ></el-option>

            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="tailleSelectPopup">
          <el-form-item v-if="selectModeleCmiste === true && listeModeles"
                        :label="$t('posts.dialog.selectModel') + ' *'" prop="prix">
            <el-select
                v-model="currentModelId"
                :placeholder="$t('posts.dialog.selectListModel')"
                v-if="listeModeles !== null"
                @change="checkModelCmisteButton"
                filterable
                clearable>
              <el-option
                  v-for="modele in listeModeles.list"
                  :key="modele.id"
                  :label="modele.reference + ' - ' + modele.titre"
                  :value="modele.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="selectModeleCmiste === true">
        <el-col :span="24">
          <el-form-item :label="$t('posts.dialog.selectModelProgram') + ' *'" prop="prix">
            <el-select
                v-model="currentProgramId"
                @change="checkModelCmisteButton"
                :placeholder="$t('posts.dialog.selectModelProgram')"
                v-if="listeProgramModeles !== null"
                filterable
                clearable>
              <el-option
                  v-for="modeleProgram in listeProgramModeles.list"
                  :key="modeleProgram.id"
                  :label="modeleProgram.reference + ' - ' + modeleProgram.titre"
                  :value="modeleProgram.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item :label="$t('posts.edit.reference')" prop="reference">
        <el-input v-model="referenceDupli" @input="checkModelCmisteButton"></el-input>
      </el-form-item>
      <span slot="footer" class="dialog-footer">
                <el-button @click.prevent="cancelMerge">{{$t('posts.dialog.cancel')}}</el-button>
                <el-button type="primary" @click.prevent="mergePosts" :disabled="modalCmisteModelDisabled">{{$t('posts.dialog.confirm')}}</el-button>
            </span>
    </el-dialog>
    <!--            Informations principales -->
    <div v-show="currentTab === 'main'">
      <ubi-panel>
        <!-- Cas d'un programme -->
        <el-container v-if="(isPromoteur && !filter.annonceParente) || (isBailleurSocial && !filter.annonceParente && (filter.creationProgramme || (post.typeObjet >= 3000 && post.typeObjet < 4000)))">
          <el-aside width="30%">
            <h3>{{ $t('posts.edit.mainInformationTitle') }}</h3>
            <p class="text-justify" v-html="$t('posts.edit.mainInformationText')"/>

            <em class="el-icon-check" v-if="post.typeObjet"></em>
            <em class="el-icon-close red" v-else></em>
            {{ $t('posts.edit.propertyType') }}
            <br/>
            <em class="el-icon-check" v-if="post.titre != null && post.titre.length > 1"></em>
            <em class="el-icon-close red" v-if="post.titre == null || post.titre.length <= 1"></em>
            {{ $t('posts.edit.title') }}
            <br/>
            <em class="el-icon-check" v-if="post.prix_min != null && post.prix_min !== ''"></em>
            <em class="el-icon-close red" v-if="post.prix_min == null ||  post.prix_min === ''"></em>
            {{ $t('posts.edit.price') }}
            <br/>
            <em class="el-icon-check" v-if="post.texte != null && post.texte.length > 10"></em>
            <em class="el-icon-close red" v-if="post.texte == null ||  post.texte.length <= 10"></em>
            {{ $t('posts.edit.description') }}
            <br/>
            <em
                class="el-icon-check"
                v-if="post.code_postal_reel != null && post.ville_reelle!= null
                        && post.code_postal_reel.length > 1
                        && post.ville_reelle.length > 1"
            ></em>
            <em
                class="el-icon-close red"
                v-if="post.code_postal_reel == null || post.ville_reelle== null
                        || post.code_postal_reel.length <= 1
                        || post.ville_reelle.length <= 1"
            ></em> {{ $t('posts.edit.location') }}
            <br/>
            <em
                class="el-icon-check"
                v-if="post.surface_min!='' && post.surface_min!=null"
            ></em>
            <em
                class="el-icon-close red"
                v-if="post.surface_min=='' || post.surface_min==null"
            ></em> {{ $t('posts.edit.surfaceHabitable') }}
            <br/>
            <br/>
            <div v-if="post.id">
              <span slot="description" v-if="post.id" v-html="$t('posts.edit.editPostNonEditablesFieldsImmo')"></span>
            </div>
          </el-aside>
          <el-main>
            <PostFormObjectType :post="post" :min-level="3" :is-program-bailleur="isProgramBailleur"
                                :label="$t('posts.edit.programType')"></PostFormObjectType>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$labels.programme_neuf_nom">
                  <el-input v-model="post.programme_neuf_nom"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$labels.residence_type">
                  <el-select
                      :placeholder="$t('posts.edit.selectTypePlaceholder')"
                      clearable
                      filterable
                      v-model="post.residence_type"
                  >
                    <el-option
                        :key="typologieResidenceChoice"
                        :label="typologieResidenceChoice"
                        :value="typologieResidenceChoice"
                        style="text-transform:capitalize"
                        v-for="typologieResidenceChoice in this.getChoices('residence_type')"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item :label="$t('posts.edit.linkToProgramOnline')">
                  <el-input v-model="post.url_annonce_sur_site_annonceur"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item :label="$t('posts.edit.shortDescription')">
                  <div style="margin-top: -40px; margin-left: 140px;">
                    <el-tooltip class="item" effect="dark" :content="$t('posts.edit.tooltipTexteResume')"
                                placement="bottom">
                      <em class="el-icon-question"></em>
                    </el-tooltip>
                  </div>
                  <el-input v-model="post.texte_resume"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">

                <el-form-item :label="$t('posts.edit.reference')" prop="reference">
                  <div style="margin-top: -40px; margin-left: 180px;">
                    <el-tooltip class="item" effect="dark" :content="$t('posts.edit.tooltipReference')"
                                placement="bottom">
                      <em class="el-icon-question"></em>
                    </el-tooltip>
                  </div>
                  <el-input :disabled="!create && post.reference != null" v-model="post.reference"
                            :value="chargementValue()"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24" v-if="isBailleurSocial">
                <el-form-item :label="$t('posts.edit.idRPLS')" prop="idRPLS">
                  <el-input v-model="post.id_rpls"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item :label="$t('posts.edit.title') + ' *'" prop="titre">
                  <el-input v-model="post.titre" :disabled="desactiverTitre"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="24">
                <el-form-item :label="$t('posts.edit.adText') + ' *'" prop="texte">
                  <el-input :rows="5" type="textarea" v-model="post.localText" :disabled="desactiverTexte" @change="handleTexte"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item :label="$labels.prix_min + ' *'" prop="prix">
                  <el-input autocomplete="off" type="prix" v-model.number="post.prix_min">
                    <div slot="append">{{ getDevise }}</div>
                  </el-input>
                </el-form-item>
              </el-col>

              <el-col :span="10">
                <el-form-item :label="$labels.prix_max" prop="prix_max">
                  <el-input autocomplete="off" type="prix" v-model.number="post.prix_max">
                    <div slot="append">{{getDevise}}</div>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item :label="$labels.devise_iso_4217">
                  <el-select
                      v-model="post.devise_iso_4217"
                      @change="deviseSelect(post.devise_iso_4217)"
                      :value="valueDevise"
                      filterable
                      default-first-option
                  >
                    <el-option
                        style="text-transform:capitalize"
                        v-for="deviseChoice in this.getChoices('devise_iso_4217')"
                        :key="deviseChoice"
                        :label="deviseChoice"
                        :value="deviseChoice"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="24">
                <el-form-item :label="$labels.type_plafond_ressources" v-if="user.isUSH">
                  <el-select
                      v-model="post.type_plafond_ressources"
                      @change="deviseSelect(post.type_plafond_ressources)"
                      :value="type_plafond_ressources"
                      filterable
                      default-first-option
                  >
                    <el-option
                        style="text-transform:capitalize"
                        v-for="typePlafondChoice in this.getChoices('type_plafond_ressources')"
                        :key="typePlafondChoice"
                        :label="typePlafondChoice"
                        :value="typePlafondChoice"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="24">
                <el-form-item :label="$labels.plafond_ressources" v-if="user.isUSH">
                  <el-input autocomplete="off" type="prix" v-model.number="post.plafond_ressources">
                    <div slot="append">{{ getDevise }}</div>
                  </el-input>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item :label="$labels.surface_min" prop="surface_min">
                  <el-input autocomplete="off" type="surface" v-model.number="post.surface_min">
                    <div slot="append">M²</div>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$labels.surface_max" prop="surface_maxi">
                  <el-input autocomplete="off" type="surface" v-model.number="post.surface_max">
                    <div slot="append">M²</div>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8" v-if="post.typeObjet != 3300">
                <el-form-item :label="$labels.nombre_etages" prop="nombre_etages">
                  <el-input autocomplete="off" type="surface" v-model.number="post.nombre_etages">
                  </el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item :label="$labels.nb_bien" prop="nb_bien">
                  <el-input autocomplete="off" v-model.number="post.nb_bien"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$labels.nb_biens_disponibles" prop="nb_biens_disponibles">
                  <el-input autocomplete="off"
                            v-model.number="post.nb_biens_disponibles"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item :label="$labels.bioconstruction">
                  <el-radio label="oui" v-model="post.bioconstruction">{{ $t("general.yes") }}</el-radio>
                  <el-radio label="non" v-model="post.bioconstruction">{{ $t("general.no") }}</el-radio>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item :label="$labels.eco_quartier">
                  <el-radio label="oui" v-model="post.eco_quartier">{{ $t("general.yes") }}</el-radio>
                  <el-radio label="non" v-model="post.eco_quartier">{{ $t("general.no") }}</el-radio>
                </el-form-item>
              </el-col>
            </el-row>
          </el-main>
        </el-container>

        <!-- Cas d'un lot promoteur -->
        <el-container v-else-if="(isPromoteur || isBailleurSocial) && filter.annonceParente">
          <el-aside width="30%">
            <h3>{{ $t('posts.edit.mainInformationTitle') }}</h3>
            <p class="text-justify" v-html="$t('posts.edit.mainInformationText')"/>
            <!--
            <em class="el-icon-check" v-if="post.typeOffre"></em>
            <em class="el-icon-close red" v-else></em>
            Type d'offre
            <br />
            -->
            <em class="el-icon-check" v-if="post.typeObjet"></em>
            <em class="el-icon-close red" v-else></em>
            {{ $t('posts.edit.propertyType') }}
            <br/>

            <em class="el-icon-check" v-if="post.titre != null && post.titre.length > 1"></em>
            <em class="el-icon-close red" v-if="post.titre == null || post.titre.length <= 1"></em>
            {{ $t('posts.edit.title') }}
            <br/>
            <em class="el-icon-check" v-if="post.prix > 0"></em>
            <em class="el-icon-close red" v-if="post.prix == null ||  post.prix.length <= 1"></em>
            {{ $t('posts.edit.price') }}
            <br/>
            <em class="el-icon-check" v-if="post.texte != null && post.texte.length > 10"></em>
            <em class="el-icon-close red" v-if="post.texte == null ||  post.texte.length <= 10"></em>
            {{ $t('posts.edit.description') }}
            <br/>
            <br/>
            <br/>
          </el-aside>
          <el-main>
            <el-col :span="24">
              <el-form-item>
                <div style="font-size: 0.8125rem; font-family: Open Sans,Helvetica,Arial,sans-serif;">
                  {{$labels.programme_neuf_nom}}
                </div>
                <el-input v-model="nomProgram" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <!--<PostFormOfferType :post="post"></PostFormOfferType>-->
            <PostFormObjectType :post="post" :min-level="3"></PostFormObjectType>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('posts.edit.reference')" prop="reference">
                  <div style="margin-top: -40px; margin-left: 180px;">
                    <el-tooltip class="item" effect="dark" :content="$t('posts.edit.tooltipReference')"
                                placement="bottom">
                      <em class="el-icon-question"></em>
                    </el-tooltip>
                  </div>
                  <el-input :disabled="!create" v-model="post.reference" :value="chargementValue()"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="isBailleurSocial">
                <el-form-item :label="$t('posts.edit.idRPLS')" prop="idRPLS">
                  <el-input v-model="post.id_rpls"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$labels.numero_reference_lot">
                  <el-input v-model="post.numero_reference_lot"></el-input>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item :label="$labels.disponibilite_lot">
                  <el-select v-model="post.disponibilite_lot"
                             clearable
                             filterable
                  >
                    <el-option
                        :key="typeDisponibilite"
                        :label="typeDisponibilite"
                        :value="typeDisponibilite"
                        style="text-transform:capitalize"
                        v-for="typeDisponibilite in this.getChoices('disponibilite_lot')"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$labels.residence_type">
                  <el-select
                      :placeholder="$t('posts.edit.selectTypePlaceholder')"
                      clearable
                      filterable
                      v-model="post.residence_type"
                  >
                    <el-option
                        :key="typologieResidenceChoice"
                        :label="typologieResidenceChoice"
                        :value="typologieResidenceChoice"
                        style="text-transform:capitalize"
                        v-for="typologieResidenceChoice in this.getChoices('residence_type')"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item :label="$t('posts.edit.title') + ' *'" prop="titre">
                  <el-input v-model="post.titre" :disabled="desactiverTitre"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="20">
                <el-form-item :label="$t('posts.edit.price') + ' *'" prop="prix">
                  <el-input autocomplete="off" type="prix" v-model.number="post.prix">
                    <div slot="append">{{getDevise}}</div>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item :label="$labels.devise_iso_4217">
                  <el-select
                      v-model="post.devise_iso_4217"
                      @change="deviseSelect(post.devise_iso_4217)"
                      :value="valueDevise"
                      filterable
                      default-first-option
                  >
                    <el-option
                        style="text-transform:capitalize"
                        v-for="deviseChoice in this.getChoices('devise_iso_4217')"
                        :key="deviseChoice"
                        :label="deviseChoice"
                        :value="deviseChoice"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="7">
                <el-form-item :label="$labels.afficher_prix + ' *'" prop="afficher_prix" icon="el-icon-question">
                  <div style="margin-top: -40px; margin-left: 120px;">
                    <el-tooltip class="item" effect="dark" :content="$t('posts.edit.tooltipReference')"
                                placement="bottom">
                      <em class="el-icon-question"></em>
                    </el-tooltip>
                  </div>
                  <el-radio label="oui" v-model="post.afficher_prix">{{ $t("general.yes") }}</el-radio>
                  <el-radio label="non" v-model="post.afficher_prix">{{ $t("general.no") }}</el-radio>
                </el-form-item>
              </el-col>
<!--              <el-col :span="12">-->
<!--                <el-tooltip placement="top-start" :content="$t('posts.edit.showPriceTooltip')">-->
<!--                  <em class="el-icon-question"></em>-->
<!--                </el-tooltip>-->
<!--              </el-col>-->

              <el-col :span="24">
                <el-form-item :label="$labels.type_plafond_ressources" v-if="user.isUSH">
                  <el-select
                      v-model="post.type_plafond_ressources"
                      @change="deviseSelect(post.type_plafond_ressources)"
                      :value="type_plafond_ressources"
                      filterable
                      default-first-option
                  >
                    <el-option
                        style="text-transform:capitalize"
                        v-for="typePlafondChoice in this.getChoices('type_plafond_ressources')"
                        :key="typePlafondChoice"
                        :label="typePlafondChoice"
                        :value="typePlafondChoice"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="24">
                <el-form-item :label="$labels.plafond_ressources" v-if="user.isUSH">
                  <el-input autocomplete="off" type="prix" v-model.number="post.plafond_ressources">
                    <div slot="append">{{ getDevise }}</div>
                  </el-input>
                </el-form-item>
              </el-col>

              <el-col :span="24">
                <el-form-item :label="$t('posts.edit.adText') + ' *'" prop="texte">
                  <el-input :rows="5" type="textarea" v-model="post.localText"
                            @input="changeForLot('type_jardin')"
                            :disabled="desactiverTexte"
                            @change="handleTexte"
                            :value="valueChangeLot"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-main>
        </el-container>

        <!--DEBUT Cas CMIste-->
        <el-container v-else-if="this.isCmiste">
          <el-aside width="30%">
            <h3>{{ $t('posts.edit.mainInformationTitle') }}</h3>
            <p class="text-justify" v-html="$t('posts.edit.mainInformationText')"/>

            <em class="el-icon-check" v-if="post.typeObjet"></em>
            <em class="el-icon-close red" v-else></em>
            {{ $t('posts.edit.propertyType') }}
            <br/>

            <em class="el-icon-check" v-if="post.titre != null && post.titre.length > 1"></em>
            <em class="el-icon-close red" v-if="post.titre == null || post.titre.length <= 1"></em>
            {{ $t('posts.edit.title') }}
            <br/>
            <em class="el-icon-check" v-if="post.prix > 0"></em>
            <em class="el-icon-close red" v-if="post.prix == null ||  post.prix.length <= 1"></em>
            {{ $t('posts.edit.price') }}
            <br/>
            <em class="el-icon-check" v-if="post.texte != null && post.texte.length > 10"></em>
            <em class="el-icon-close red" v-if="post.texte == null ||  post.texte.length <= 10"></em>
            {{ $t('posts.edit.description') }}
            <br/>
            <em
                class="el-icon-check"
                v-if="post.code_postal_reel!= null && post.ville_reelle!= null
                        && post.code_postal_reel.length > 1
                        && post.ville_reelle.length > 1"
            ></em>
            <em
                class="el-icon-close red"
                v-if="post.code_postal_reel== null || post.ville_reelle== null
                        || post.code_postal_reel.length <= 1
                        || post.ville_reelle.length <= 1"
            ></em> {{ $t('posts.edit.location') }}
            <br/>
            <span v-if="post.typeObjet">
              <span v-if="post.typeObjet === 1310" >
                <em class="el-icon-close red" v-if="post.surface_terrain=='' || post.surface_terrain==null"></em>
                <em class="el-icon-check" v-else></em>
                <span class="ml-1">{{ $t('posts.edit.surfaceLand') }}</span>
              </span>
              <span v-else>
                <em class="el-icon-close red" v-if="post.surface_habitable=='' || post.surface_habitable==null"></em>
                <em class="el-icon-check" v-else></em>
                <span class="ml-1">{{ $t('posts.edit.surfaceHabitable') }}</span>
              </span>
            </span>
            <br/>
            <br/>
          </el-aside>
          <el-main>
            <el-row>
              <el-col :span="24">
                <el-form-item :label="$t('posts.edit.propertyType') + ' *'" prop="typeObjet">
                  <el-radio-group v-model="post.typeObjet" @input="fetchDataModelsCmiste" :disabled="modeleCMI5200">
                    <el-radio :label="1310" v-model="post.typeObjet">{{ $t("posts.buildingLandTitle") }}</el-radio>
                    <el-radio :label="5200" v-model="post.typeObjet">{{ $t("posts.edit.typeLandHouse") }}</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="24" v-if="post.typeObjet && post.id == null">
                <el-button @click.prevent="modalShowModels = true" size="small" type="primary">{{
                    $t('posts.edit.mergeFromModels')}}
                </el-button>
                <br>
                <br>
                <br>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="10">
                <!-- CMI GO-->
                <el-form-item :label="$t('posts.edit.reference')" prop="reference">
                  <div style="margin-top: -40px; margin-left: 180px;">
                    <el-tooltip class="item" effect="dark" :content="$t('posts.edit.tooltipReference')"
                                placement="bottom">
                      <em class="el-icon-question"></em>
                    </el-tooltip>
                  </div>
                  <el-input :disabled="!create" v-model="post.reference" :value="chargementValue()"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item :label="$t('posts.edit.price') + ' *'" prop="prix">
                  <el-input autocomplete="off" type="prix" v-model.number="post.prix">
                    <div slot="append">{{getDevise}}</div>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item :label="$labels.devise_iso_4217">
                  <el-select
                      v-model="post.devise_iso_4217"
                      @change="deviseSelect(post.devise_iso_4217)"
                      :value="valueDevise"
                      filterable
                      default-first-option
                  >
                    <el-option
                        style="text-transform:capitalize"
                        v-for="deviseChoice in this.getChoices('devise_iso_4217')"
                        :key="deviseChoice"
                        :label="deviseChoice"
                        :value="deviseChoice"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item :label="$t('posts.edit.title') + ' *'" prop="titre">
                  <el-input v-model="post.titre" :disabled="desactiverTitre"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item :label="$labels.afficher_prix + ' *'" prop="afficher_prix" icon="el-icon-question">
                  <div style="margin-top: -40px; margin-left: 120px;">
                    <el-tooltip class="item" effect="dark" :content="$t('posts.edit.showPriceTooltip')"
                                placement="bottom">
                      <em class="el-icon-question"></em>
                    </el-tooltip>
                  </div>
                  <el-radio label="oui" v-model="post.afficher_prix">{{ $t("general.yes") }}</el-radio>
                  <el-radio label="non" v-model="post.afficher_prix">{{ $t("general.no") }}</el-radio>
                </el-form-item>

              </el-col>

              <!--              <el-col :span="12">-->
              <!--                <el-tooltip placement="top-start" :content="$t('posts.edit.showPriceTooltip')">-->
              <!--                  <em class="el-icon-question"></em>-->
              <!--                </el-tooltip>-->
              <!--              </el-col>-->

              <PostFormImmoSurfaceMainTab :post="post"></PostFormImmoSurfaceMainTab>

              <el-col :span="24">
                <el-form-item :label="$t('posts.edit.adText') + ' *'" prop="texte">
                  <el-input :rows="5" type="textarea" v-model="post.localText" :disabled="desactiverTexte" @change="handleTexte"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24" v-if="isARLOGIS">
                <el-form-item label="Description courte">
                  <el-input
                      :rows="2"
                      type="textarea"
                      v-model="post.texte_resume"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item
                    :label="$t('posts.urlAnnonceSiteAnnonceur')"
                    prop="url_annonce_sur_site_annonceur"
                >
                  <el-input type="url_annonce_sur_site_annonceur" v-model="post.url_annonce_sur_site_annonceur">
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item :label="$t('posts.edit.shortDescription')">
                  <div style="margin-top: -40px; margin-left: 140px;">
                    <el-tooltip class="item" effect="dark" :content="$t('posts.edit.tooltipTexteResume')"
                                placement="bottom">
                      <em class="el-icon-question"></em>
                    </el-tooltip>
                  </div>
                  <el-input v-model="post.texte_resume"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-main>
        </el-container>
        <!--FIN Cas CMIste-->

        <!-- Cas normal, autre qu'un programme -->
        <el-container v-else>
          <el-aside width="30%">
            <h3>{{ $t('posts.edit.mainInformationTitle') }}</h3>
            <p class="text-justify" v-html="$t('posts.edit.mainInformationText')"/>

            <em class="el-icon-check" v-if="post.typeOffre"></em>
            <em class="el-icon-close red" v-else></em>
            {{ $t('posts.edit.offerType') }}
            <br/>

            <em class="el-icon-check" v-if="post.typeObjet"></em>
            <em class="el-icon-close red" v-else></em>
            {{ $t('posts.edit.propertyType') }}
            <br/>

            <em class="el-icon-check" v-if="post.titre != null && post.titre.length > 1"></em>
            <em class="el-icon-close red" v-if="post.titre == null || post.titre.length <= 1"></em>
            {{ $t('posts.edit.title') }}
            <br/>
            <em class="el-icon-check" v-if="(post.loyer_mensuel!='' && post.loyer_mensuel!=null && post.typeOffre == 'L')"></em>
            <em class="el-icon-check" v-if="(post.prix!='' && post.prix!=null && post.typeOffre != 'L')"></em>
            <em class="el-icon-close red"
                v-if="(post.prix == null || post.prix== '') && post.typeOffre != 'L'"></em>
            <em class="el-icon-close red"
                v-if="(post.loyer_mensuel == null ||  post.loyer_mensuel=='') && post.typeOffre == 'L'"></em>
            <span v-if="post.typeOffre != 'L'"> {{ $t('posts.edit.price') }}</span>
            <span v-else> {{ $t('posts.edit.rent') }}</span>
            <br/>
            <em class="el-icon-check" v-if="post.texte != null && post.texte.length > 10"></em>
            <em class="el-icon-close red" v-if="post.texte == null ||  post.texte.length <= 10"></em>
            {{ $t('posts.edit.description') }}
            <br/>
            <em
                class="el-icon-check"
                v-if="post.code_postal_reel!= null && post.ville_reelle!= null
                        && post.code_postal_reel.length > 1
                        && post.ville_reelle.length > 1"
            ></em>
            <em
                class="el-icon-close red"
                v-if="post.code_postal_reel== null || post.ville_reelle== null
                        || post.code_postal_reel.length <= 1
                        || post.ville_reelle.length <= 1"
            ></em> {{ $t('posts.edit.location') }}
            <br/>
            <span v-if="(post.typeObjet == 1300) || (post.typeObjet == 1310)" >
              <em class="el-icon-close red" v-if="post.surface_terrain=='' || post.surface_terrain==null"></em>
              <em class="el-icon-check" v-else></em>
              <span class="ml-1">{{ $t('posts.edit.surfaceLand') }}</span>
            </span>
            <span v-else-if="post.typeObjet < 2000 || !post.typeObjet || (post.typeObjet === 2420)" >
              <em class="el-icon-close red" v-if="post.surface_habitable=='' || post.surface_habitable==null"></em>
              <em class="el-icon-check" v-else></em>
              <span class="ml-1">{{ $t('posts.edit.surfaceHabitable') }}</span>
            </span>
            <span v-else-if="post.typeObjet >= 2300 && post.typeObjet !== 2420 && post.typeObjet !== 2900">
              <em class="el-icon-close red" v-if="post.surface_commerciale=='' || post.surface_commerciale==null"></em>
              <em class="el-icon-check" v-else></em>
              <span class="ml-1">{{ $t('posts.edit.surfaceCommerciale') }}</span>
            </span>
            <span v-else>
              <em class="el-icon-close red" v-if="post.surface_activite=='' || post.surface_activite==null"></em>
              <em class="el-icon-check" v-else></em>
              <span class="ml-1">{{ $t('posts.edit.surfaceActivite') }}</span>
            </span>
            <span v-if="post.honoraires_payeurs=='acquéreur' || post.honoraires_payeurs=='acquéreur et vendeur'">
              <em class="el-icon-close red" v-if="post.honoraires_negociation=='' || post.honoraires_negociation==null"></em>
              <em class="el-icon-check" v-else></em>
              {{ $t('posts.edit.buyerShare') }}
              <br/>
            </span>
            <br/>
          </el-aside>
          <el-main>
            <PostFormOfferType :post="post" :desactiverChamp="desactiverChamp"></PostFormOfferType>
            <PostFormObjectType :post="post" :desactiverChamp="desactiverChamp" v-on:typeChange="typeChange"></PostFormObjectType>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item :label="$t('posts.edit.reference')" prop="reference">
                  <div style="margin-top: -40px; margin-left: 180px;">
                    <el-tooltip class="item" effect="dark" :content="$t('posts.edit.tooltipReference')"
                                placement="bottom">
                      <em class="el-icon-question"></em>
                    </el-tooltip>
                  </div>
                  <el-input :disabled="!create" v-model="post.reference" :value="chargementValue()"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="24" v-if="isBailleurSocial">
                <el-form-item :label="$t('posts.edit.idRPLS')" prop="idRPLS">
                  <el-input v-model="post.id_rpls"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item :label="$labels.residence_type">
                  <el-select
                      :placeholder="$t('posts.edit.selectTypePlaceholder')"
                      clearable
                      filterable
                      v-model="post.residence_type"
                  >
                    <el-option
                        :key="typologieResidenceChoice"
                        :label="typologieResidenceChoice"
                        :value="typologieResidenceChoice"
                        style="text-transform:capitalize"
                        v-for="typologieResidenceChoice in this.getChoices('residence_type')"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="24">
                <el-form-item :label="$t('posts.edit.title') + ' *'" prop="titre">
                  <el-input v-model="post.titre" :disabled="desactiverTitre"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="20" v-if="post.typeOffre != 'L' && post.typeOffre != 'S'">
                <el-form-item :label="$t('posts.edit.price') + ' *'" prop="prix">
                  <el-input autocomplete="off" type="prix" v-model.number="post.prix">
                    <div slot="append">{{getDevise}}</div>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="20" v-else-if="post.typeOffre == 'S'">
                <el-form-item :label="$t('posts.edit.price') + ' *'" prop="prix">
                  <el-input autocomplete="off" type="prix" v-model.number="post.prix" @change="setLocSaisonnierePrix">
                    <div slot="append">{{getDevise}}</div>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="20" v-else>
                <el-form-item :label="$t('posts.edit.rent') + ' *'" prop="loyer_mensuel">
                  <el-input autocomplete="off" type="loyer_mensuel" v-model.number="post.loyer_mensuel">
                    <div slot="append">{{getDevise}}</div>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item :label="$labels.devise_iso_4217">
                  <el-select
                      v-model="post.devise_iso_4217"
                      @change="deviseSelect(post.devise_iso_4217)"
                      :value="valueDevise"
                      filterable
                      default-first-option
                  >
                    <el-option
                        style="text-transform:capitalize"
                        v-for="deviseChoice in this.getChoices('devise_iso_4217')"
                        :key="deviseChoice"
                        :label="deviseChoice"
                        :value="deviseChoice"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col class="mb-2" v-if="post.typeOffre === 'L'">
                <el-form-item :label="$labels.loyer_est_cc">
                  <el-radio-group v-model="post.loyer_est_cc" @change="changeLoyerCC()">
                    <el-radio label="oui">{{
                        $t("general.yes") }}
                    </el-radio>
                    <el-radio label="non">{{
                        $t("general.no") }}
                    </el-radio>
                  </el-radio-group>
                </el-form-item>

              </el-col>
              <el-col :span="7">
                <el-form-item :label="$labels.afficher_prix + ' *'" prop="afficher_prix" icon="el-icon-question">
                  <div style="margin-top: -40px; margin-left: 120px;">
                    <el-tooltip class="item" effect="dark" :content="$t('posts.edit.showPriceTooltip')"
                                placement="bottom">
                      <em class="el-icon-question"></em>
                    </el-tooltip>
                  </div>
                  <el-radio label="oui" @change="disableChampsLocSaisonniere" v-model="post.afficher_prix">{{
                      $t("general.yes") }}
                  </el-radio>
                  <el-radio label="non" @change="disableChampsLocSaisonniere" v-model="post.afficher_prix">{{
                      $t("general.no") }}
                  </el-radio>
                </el-form-item>
              </el-col>
              <!--              <el-col :span="12">-->
              <!--                <el-tooltip placement="top-start" :content="$t('posts.edit.showPriceTooltip')">-->
              <!--                  <em class="el-icon-question"></em>-->
              <!--                </el-tooltip>-->
              <!--              </el-col>-->

              <PostFormImmoSurfaceMainTab :post="post"></PostFormImmoSurfaceMainTab>

              <el-col :span="12" v-if="(post.typeObjet >= 2000) && (post.typeObjet < 3000)">
                <el-form-item :label="$labels.liste_activites_commerce">
                  <el-select
                      :placeholder="$t('posts.edit.activitesCommercePlaceholder')"
                      clearable
                      filterable
                      v-model="post.liste_activites_commerce"
                  >
                    <el-option
                        :key="activite_commerce"
                        :label="activite_commerce"
                        :value="activite_commerce"
                        style="text-transform:capitalize"
                        v-for="activite_commerce in this.getChoices('referentiel_activites_commerce')"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="24" v-if="isUSH">
                <el-form-item
                    v-if="post.typeObjet >= 1300 && post.typeObjet < 1500"
                    :label="$labels.nb_pieces_logement"
                    prop="nb_pieces_logement"

                >
                  <el-input v-mask="'#################'" v-model.number="post.nb_pieces_logement"
                            type="nb_pieces_logement"></el-input>
                </el-form-item>
                <el-form-item
                    v-else
                    :label="$labels.nb_pieces_logement + ' *'"
                    prop="nb_pieces_logement"

                >
                  <el-input v-mask="'#################'" v-model.number="post.nb_pieces_logement"
                            type="nb_pieces_logement"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="24">
                <el-form-item :label="$labels.type_plafond_ressources" v-if="user.isUSH">
                  <el-select
                      v-model="post.type_plafond_ressources"
                      @change="deviseSelect(post.type_plafond_ressources)"
                      :value="type_plafond_ressources"
                      filterable
                      default-first-option
                  >
                    <el-option
                        style="text-transform:capitalize"
                        v-for="typePlafondChoice in this.getChoices('type_plafond_ressources')"
                        :key="typePlafondChoice"
                        :label="typePlafondChoice"
                        :value="typePlafondChoice"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="24">
                <el-form-item :label="$labels.plafond_ressources" v-if="user.isUSH">
                  <el-input autocomplete="off" type="prix" v-model.number="post.plafond_ressources">
                    <div slot="append">{{ getDevise }}</div>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item :label="$t('posts.edit.adText') + ' *'" prop="localText">
                  <el-input :rows="5" type="textarea" v-model="post.localText" :disabled="desactiverTexte" @change="handleTexte"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="24">
                <el-form-item
                    :label="$t('posts.urlAnnonceSiteAnnonceur')"
                    prop="url_annonce_sur_site_annonceur"
                >
                  <el-input type="url_annonce_sur_site_annonceur" v-model="post.url_annonce_sur_site_annonceur">
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item :label="$t('posts.edit.shortDescription')">
                  <div style="margin-top: -40px; margin-left: 140px;">
                    <el-tooltip class="item" effect="dark" :content="$t('posts.edit.tooltipTexteResume')"
                                placement="bottom">
                      <em class="el-icon-question"></em>
                    </el-tooltip>
                  </div>
                  <el-input v-model="post.texte_resume"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$labels.prestige" prop="prestige">
                  <el-radio-group v-model="post.prestige">
                    <el-radio label="oui" value="oui" v-model="post.prestige">{{ $t("general.yes") }}</el-radio>
                    <el-radio label="non" value="non" v-model="post.prestige">{{ $t("general.no") }}</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('posts.edit.affichage_privilegie')" prop="affichage_privilegie">
                  <el-radio-group v-model="post.affichage_privilegie">
                    <el-radio label="oui" value="oui" v-model="post.affichage_privilegie">{{ $t("general.yes") }}</el-radio>
                    <el-radio label="non" value="non" v-model="post.affichage_privilegie">{{ $t("general.no") }}</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
          </el-main>
        </el-container>
      </ubi-panel>

      <ubi-panel>
        <el-container v-if="isPromoteur && !filter.annonceParente">
          <el-aside width="30%">
            <h3>{{ $t("posts.edit.programAddressTitle") }}</h3>
            <p class="text-justify" v-html="$t('posts.edit.programAddressText')"/>
          </el-aside>
          <el-main>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$labels.pays" prop="pays">
                  <el-select
                      v-model="paysValue"
                      filterable
                      clearable
                      @change="selectPays"
                  >
                    <el-option
                        :key="pays.libelle"
                        :label="pays.translated_name"
                        :value="pays.libelle"
                        v-for="pays in getCountries"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :md="6" :xs="24">
                <el-form-item :label="$labels.latitude" prop="latitude">
                  <el-input v-model="post.latitude"></el-input>
                </el-form-item>
              </el-col>
              <el-col :md="6" :xs="24">
                <el-form-item :label="$labels.longitude" prop="longitude">
                  <el-input v-model="post.longitude"></el-input>
                </el-form-item>
              </el-col>
              <el-col :md="12" :xs="24">
                <el-form-item :label="$labels.code_postal + ' *'" prop="code_postal_reel">
                  <el-autocomplete
                      class="inline-input"
                      v-model="post.code_postal_reel"
                      :fetch-suggestions="searchPostal"
                      @select="selectPostalReel"></el-autocomplete>
                </el-form-item>
              </el-col>
              <el-col :md="12" :xs="24">
                <el-form-item :label="$labels.ville + ' *'" prop="ville_reelle">
                  <el-input v-model="post.ville_reelle"></el-input>
                </el-form-item>
              </el-col>
              <el-col :md="6" :xs="24">
                <el-form-item :label="$labels.numero_voie" prop="numero_voie">
                  <el-input v-model.number="post.numero_voie"></el-input>
                </el-form-item>
              </el-col>
              <el-col :md="6" :xs="24">
                <el-form-item :label="$labels.type_voie">
                  <el-select
                      :placeholder="$t('posts.edit.selectTypePlaceholder')"
                      clearable
                      filterable
                      v-model="post.type_voie"
                  >
                    <el-option
                        :key="typeVoieChoice"
                        :label="typeVoieChoice"
                        :value="typeVoieChoice"
                        style="text-transform:capitalize"
                        v-for="typeVoieChoice in this.getChoices('type_voie')"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :md="12" :xs="24">
                <el-form-item :label="$t('posts.edit.address')">
                  <el-input v-model="post.nom_voie"></el-input>
                </el-form-item>
              </el-col>
              <el-col :md="24" :xs="24">
                <el-form-item :label="$labels.quartier">
                  <el-input v-model="post.quartier"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item :label="$labels.adresse2">
                  <el-input :rows="5" type="textarea" v-model="post.adresse2"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24" v-if="isPromoteur">
                <el-form-item :label="$labels.bureau_vente_adresse">
                  <el-input :rows="5" type="textarea" v-model="post.bureau_vente_adresse"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="8" v-if="isCmiste == false">
                <el-form-item style="font-weight: bold;" prop="communiquer_adresse_exacte">

                  <strong>{{ $labels.communiquer_adresse_exacte }} *</strong>
                  <div style="margin-top: -40px; margin-left: 250px;">
                    <el-tooltip class="item" effect="dark" :content="$t('posts.edit.exactAddressTooltip')"
                                placement="bottom">
                      <em class="el-icon-question"></em>
                    </el-tooltip>
                  </div>
                  <el-radio-group v-model="post.communiquer_adresse_exacte">
                    <el-radio label="oui" value="oui">{{ $t("general.yes") }}</el-radio>
                    <el-radio label="non" value="non">{{ $t("general.no") }}</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>

              <!--              <el-col :span="12" v-if="isCmiste == false">-->
              <!--                  <el-tooltip placement="top-start" :content="$t('posts.edit.exactAddressTooltip')">-->
              <!--                    <em class="el-icon-question"></em>-->
              <!--                  </el-tooltip>-->
              <!--              </el-col>-->
            </el-row>
            <el-row :gutter="20" v-if="post.communiquer_adresse_exacte === 'non'">
              <el-col :span="24">
                <hr/>
              </el-col>
              <el-col :span="24">
                <h4>{{ $t("posts.edit.locationToPublishTitle") }}</h4>
              </el-col>
              <el-col :md="12" :xs="24">
                <el-form-item :label="$labels.code_postal + ' *'" prop="code_postal">
                  <el-autocomplete
                      class="inline-input"
                      v-model="post.code_postal"
                      :fetch-suggestions="searchPostal"
                      @select="selectPostal"></el-autocomplete>
                </el-form-item>
              </el-col>
              <el-col :md="12" :xs="24">
                <el-form-item :label="$labels.ville + ' *'" prop="ville">
                  <el-input v-model="post.ville"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-main>
        </el-container>
        <!-- Cas d'une saisie d'un lot promoteur, pas de données de localisation, on switche plutot sur les infos de l'interieur -->
        <el-container v-else-if="(isPromoteur || isBailleurSocial) && filter.annonceParente && (post.annonce_parente_type_objet != 3300)">
          <el-aside width="30%">
            <h3>{{ $t("posts.edit.interiorTitle") }}</h3>
          </el-aside>
          <el-main>
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item
                    :rules="[
									{ type: 'number', message: this.$t('validator.mustBeNumericValue')}
							  ]"
                    :label="$labels.nombre_etages"
                    prop="nombre_etages"
                >
                  <el-input type="nombre_etages" v-model.number="post.nombre_etages"
                            @input="changeForLot('nombre_etages')" :value="valueChangeLot"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                    :rules="[
								  { type: 'number', message: this.$t('validator.mustBeNumericValue')}
							]"
                    :label="$labels.etage"
                    prop="etage"
                >
                  <el-input type="etage" v-model.number="post.etage" @input="changeForLot('etage')"
                            :value="valueChangeLot"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="8" style="margin-top: 30px">
                <el-form-item>
                  <el-checkbox false-label="non" true-label="oui" v-model="post.duplex"
                               @change="changeCheckboxLot('duplex')" :checked="isChecked">{{$labels.duplex}}
                  </el-checkbox>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item
                    :label="$labels.surface_habitable + ' *'"
                    prop="surface_habitable"
                >
                  <el-input type="number" step='0.01' v-model="post.surface_habitable"
                            @input="changeForLot('surface_habitable')" :value="valueChangeLot">
                    <div slot="append">m²</div>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                    :rules="[
							  { type: 'number', message: this.$t('validator.mustBeNumericValue')}
							]"
                    :label="$labels.nb_pieces_logement"
                    prop="nb_pieces_logement"
                >
                  <el-input type="nb_pieces_logement"
                            v-model.number="post.nb_pieces_logement" @input="changeForLot('nb_pieces_logement')"
                            :value="valueChangeLot"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                    :rules="[
										{ type: 'number', message: this.$t('validator.mustBeNumericValue')}
								  ]"
                    :label="$labels.nombre_de_chambres"
                    prop="nombre_de_chambres"
                >
                  <el-input type="nombre_de_chambres"
                            v-model.number="post.nombre_de_chambres" @input="changeForLot('nombre_de_chambres')"
                            :value="valueChangeLot"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item
                    :rules="[
										{ type: 'number', message: this.$t('validator.mustBeNumericValue')}
								  ]"
                    :label="$labels.nb_salles_d_eau"
                    prop="nb_salles_d_eau"
                >
                  <el-input type="nb_salles_d_eau"
                            v-model.number="post.nb_salles_d_eau" @input="changeForLot('nb_salles_d_eau')"
                            :value="valueChangeLot"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                    :rules="[
										{ type: 'number', message: this.$t('validator.mustBeNumericValue')}
								  ]"
                    :label="$labels.nb_salles_de_bain"
                    prop="nb_salles_de_bain"
                >
                  <el-input type="nb_salles_de_bain"
                            v-model.number="post.nb_salles_de_bain" @input="changeForLot('nb_salles_de_bain')"
                            :value="valueChangeLot"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                    :rules="[
										{ type: 'number', message: this.$t('validator.mustBeNumericValue')}
								  ]"
                    label="WC"
                    prop="nb_wc"
                >
                  <el-input type="nb_wc" v-model.number="post.nb_wc" @input="changeForLot('nb_wc')"
                            :value="valueChangeLot"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6" style="margin-top: 30px">
                <el-form-item>
                  <el-checkbox false-label true-label="oui" v-model="post.wc_independant"
                               @change="changeCheckboxLot('wc_independant')" :checked="isChecked">
                    {{$labels.wc_independant}}
                  </el-checkbox>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item

                    :label="$labels.surface_sejour"
                    prop="surface_sejour"
                >
                  <el-input type="surface_sejour" v-model.number="post.surface_sejour"
                            @input="changeForLot('surface_sejour')" :value="valueChangeLot">
                    <div slot="append">m²</div>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                    :label="$labels.surface_salle_a_manger"
                    prop="surface_salle_a_manger"
                >
                  <el-input
                      type="surface_salle_a_manger"
                      v-model.number="post.surface_salle_a_manger" @input="changeForLot('surface_salle_a_manger')"
                      :value="valueChangeLot"
                  >
                    <div slot="append">m²</div>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">

              <el-col :span="24">
                <el-form-item :label="$labels.grenier">
                  <el-radio-group v-model="post.grenier" @change="changeForLot('grenier')" :value="valueChangeLot">
                    <el-radio label="oui" value="oui">{{ $t("general.yes") }}</el-radio>
                    <el-radio label="non" value="non">{{ $t("general.no") }}</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item>
                  <div style="font-size: 12px;">{{$labels.type_cuisine}}
                    <el-button @click="post.type_cuisine = null"
                               circle
                               class="el-icon-error reset-radio"
                               v-if="post.type_cuisine != '' && post.type_cuisine != undefined && post.type_cuisine != null"></el-button>
                  </div>
                  <el-radio-group v-model="post.type_cuisine" @change="changeForLot('type_cuisine')"
                                  :value="valueChangeLot">
                    <el-radio
                        :label="cuisineChoice"
                        :value="cuisineChoice"
                        v-for="cuisineChoice in this.getChoices('type_cuisine')">
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>

              <el-col>
                <el-form-item :label="$t('posts.edit.interiorServices')">
                  <el-checkbox false-label="non" true-label="oui" v-model="post.sejour"
                               @change="changeCheckboxLot('sejour')" :checked="isChecked">
                    {{ $labels.sejour }}
                  </el-checkbox>
                  <el-checkbox false-label="non" true-label="oui" v-model="post.salle_a_manger"
                               @change="changeCheckboxLot('salle_a_manger')" :checked="isChecked">
                    {{ $labels.salle_a_manger }}
                  </el-checkbox>
                  <el-checkbox false-label="non" true-label="oui" v-model="post.coin_bureau"
                               @change="changeCheckboxLot('coin_bureau')" :checked="isChecked">
                    {{ $labels.coin_bureau }}
                  </el-checkbox>
                  <el-checkbox false-label="non" true-label="oui" v-model="post.degagement"
                               @change="changeCheckboxLot('degagement')" :checked="isChecked">
                    {{ $labels.degagement }}
                  </el-checkbox>
                  <el-checkbox false-label="non" true-label="oui" v-model="post.dressing"
                               @change="changeCheckboxLot('dressing')" :checked="isChecked">
                    {{ $labels.dressing }}
                  </el-checkbox>
                  <el-checkbox false-label="non" true-label="oui" v-model="post.buanderie"
                               @change="changeCheckboxLot('buanderie')" :checked="isChecked">
                    {{ $labels.buanderie }}
                  </el-checkbox>
                  <el-checkbox false-label="non" true-label="oui" v-model="post.possede_cajibi"
                               @change="changeCheckboxLot('possede_cajibi')" :checked="isChecked">
                    {{ $labels.possede_cajibi }}
                  </el-checkbox>
                  <el-checkbox false-label="non" true-label="oui" v-model="post.placards_integres"
                               @change="changeCheckboxLot('placards_integres')" :checked="isChecked">
                    {{ $labels.placards_integres }}
                  </el-checkbox>
                  <el-checkbox false-label="non" true-label="oui" v-model="post.loggia"
                               @change="changeCheckboxLot('loggia')" :checked="isChecked">
                    {{ $labels.loggia }}
                  </el-checkbox>
                  <el-checkbox false-label="non" true-label="oui" v-model="post.cheminee"
                               @change="changeCheckboxLot('cheminee')" :checked="isChecked">
                    {{ $labels.cheminee }}
                  </el-checkbox>
                  <el-checkbox false-label="non" true-label="oui" v-model="post.poele_a_bois"
                               @change="changeCheckboxLot('poele_a_bois')" :checked="isChecked">
                    {{ $labels.poele_a_bois }}
                  </el-checkbox>
                  <el-checkbox false-label="non" true-label="oui" v-model="post.volets_roulants_electriques"
                               @change="changeCheckboxLot('volets_roulants_electriques')" :checked="isChecked">
                    {{ $labels.volets_roulants_electriques }}
                  </el-checkbox>
                  <el-checkbox false-label="non" true-label="oui" v-model="post.climatise"
                               @change="changeCheckboxLot('climatise')" :checked="isChecked">
                    {{ $labels.climatise }}
                  </el-checkbox>
                  <el-checkbox false-label="non" true-label="oui" v-model="post.acces_handicapes"
                               @change="changeCheckboxLot('acces_handicapes')" :checked="isChecked">
                    {{ $labels.acces_handicapes }}
                  </el-checkbox>
                  <el-checkbox v-model="post.est_adapte_pmr" true-label="oui" false-label="non">
                    {{ $labels.est_adapte_pmr }}
                  </el-checkbox>
                  <el-checkbox false-label="non" true-label="oui" v-model="post.cable_tv"
                               @change="changeCheckboxLot('cable_tv')" :checked="isChecked">
                    {{ $labels.cable_tv }}
                  </el-checkbox>
                  <el-checkbox false-label="non" true-label="oui" v-model="post.acces_internet_haut_debit"
                               @change="changeCheckboxLot('acces_internet_haut_debit')" :checked="isChecked">
                    {{ $labels.acces_internet_haut_debit }}
                  </el-checkbox>
                  <el-checkbox false-label="non" true-label="oui" v-model="post.fibre_optique"
                               @change="changeCheckboxLot('fibre_optique')" :checked="isChecked">
                    {{ $labels.fibre_optique }}
                  </el-checkbox>
                </el-form-item>
              </el-col>

              <el-col :span="24">
                <el-form-item>
                  <div style="font-size: 12px;">{{$labels.vitrages}}
                    <el-button @click="post.vitrages = null"
                               circle
                               class="el-icon-error reset-radio"
                               v-if="post.vitrages != '' && post.vitrages != undefined && post.vitrages != null"></el-button>
                  </div>
                  <el-radio-group v-model="post.vitrages" @change="changeForLot('vitrages')" :value="valueChangeLot">
                    <el-radio
                        :label="natureVitrageChoice"
                        :value="natureVitrageChoice"
                        v-for="natureVitrageChoice in this.getChoices('vitrages')">
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item :label="$labels.revetement_sol_principal">
                  <el-select
                      :placeholder="$t('posts.edit.selectTypePlaceholder')"
                      clearable
                      filterable
                      v-model="post.revetement_sol_principal"
                      @change="changeForLot('revetement_sol_principal')" :value="valueChangeLot"
                  >
                    <el-option
                        :key="revetementSolChoice"
                        :label="revetementSolChoice"
                        :value="revetementSolChoice"
                        style="text-transform:capitalize"
                        v-for="revetementSolChoice in this.getChoices('revetement_sol_principal')"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-main>
        </el-container>
        <!-- Classic case-->
        <el-container v-else>
          <el-aside width="30%">
            <strong><h3>{{ $t("posts.edit.locationPropertyTitle") }}</h3></strong>
            <p class="text-justify" v-html="$t('posts.edit.locationPropertyText')"/>
          </el-aside>
          <el-main>
            <el-row :gutter="20">
              <el-col :span="24">
                <h4>{{ $t("posts.edit.exactAddressTitle") }}</h4>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item :label="$labels.pays" prop="pays">
                  <el-select
                      v-model="paysValue"
                      filterable
                      clearable
                      default-first-option
                      @change="selectPays"
                  >
                    <el-option
                        :key="pays.libelle"
                        :label="pays.translated_name"
                        :value="pays.libelle"
                        v-for="pays in getCountries"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :lg="24" v-if="isPaysMaurice">
                <el-form-item :label="$labels.schema_legal_mus">
                  <el-select
                      :placeholder="$labels.schema_legal_mus"
                      clearable
                      filterable
                      v-model="post.schema_legal_mus"
                  >
                    <el-option
                        :key="schemaLegalChoice"
                        :label="schemaLegalChoice"
                        :value="schemaLegalChoice"
                        style="text-transform:capitalize"
                        v-for="schemaLegalChoice in this.getChoices('schema_legal_mus')"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :md="24" :xs="24" v-if="post.typeObjet >= 2000 && post.typeObjet < 3000">
                <el-form-item :label="$labels.localiser_sur_departement + ' *'" prop="localiser_sur_departement">
                  <el-radio label="oui" v-model="post.localiser_sur_departement">{{ $t("general.yes") }}</el-radio>
                  <el-radio label="non" v-model="post.localiser_sur_departement">{{ $t("general.no") }}</el-radio>
                </el-form-item>
              </el-col>
              <el-col :md="12" :xs="24">
                <el-form-item :label="$labels.code_postal + ' *'" prop="code_postal_reel" v-if="!post.localiser_sur_departement || post.localiser_sur_departement === 'non'">
                  <el-autocomplete
                      class="inline-input"
                      v-model="post.code_postal_reel"
                      :fetch-suggestions="searchPostal"
                      @select="selectPostalReel"></el-autocomplete>
                </el-form-item>
                <el-form-item label="Département *" prop="code_postal_reel" v-else>
                  <el-input
                      maxlength="8"
                      class="inline-input"
                      v-model="post.code_postal_reel"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :md="12" :xs="24" v-if="post.typeObjet >= 2000 && post.typeObjet < 3000">
                <el-form-item :label="$labels.ville" prop="ville_reelle">
                  <el-input v-model="post.ville_reelle"></el-input>
                </el-form-item>
              </el-col>
              <el-col :md="12" :xs="24" v-else>
                <el-form-item :label="$labels.ville + ' *'" prop="ville_reelle">
                  <el-input v-model="post.ville_reelle"></el-input>
                </el-form-item>
              </el-col>
              <el-col :md="6" :xs="24">
                <el-form-item :label="$labels.numero_voie" prop="numero_voie">
                  <el-input v-model.number="post.numero_voie"></el-input>
                </el-form-item>
              </el-col>
              <div v-if="isARLOGIS">
                <el-col :md="6" :xs="24">
                  <el-form-item :label="$labels.type_voie">
                    <el-select
                        :placeholder="$t('posts.edit.selectTypePlaceholder')"
                        clearable
                        filterable
                        v-model="post.type_voie"
                    >
                      <el-option
                          :key="typeVoieChoice"
                          :label="typeVoieChoice"
                          :value="typeVoieChoice"
                          style="text-transform:capitalize"
                          v-for="typeVoieChoice in this.getChoices('type_voie')"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :md="12" :xs="24">
                  <el-form-item :label="$t('posts.edit.address')">
                    <el-input v-model="post.nom_voie"></el-input>
                  </el-form-item>
                </el-col>
              </div>
              <div v-else>
                <el-col :md="18" :xs="24">
                  <el-form-item :label="$t('posts.edit.address')">
                    <el-input v-model="post.nom_voie"></el-input>
                  </el-form-item>
                </el-col>
              </div>
              <el-col :md="24" :xs="24">
                <el-form-item :label="$labels.quartier">
                  <el-input v-model="post.quartier"></el-input>
                </el-form-item>
              </el-col>
              <el-col :md="24" :xs="24">
                <el-form-item :label="$labels.adresse2">
                  <el-input :rows="5" type="textarea" v-model="post.adresse2"></el-input>
                </el-form-item>
              </el-col>
              <el-col :md="12" :xs="12">
                <el-form-item :label="$labels.latitude">
                  <el-input v-model="post.latitude"></el-input>
                </el-form-item>
              </el-col>
              <el-col :md="12" :xs="12">
                <el-form-item :label="$labels.longitude">
                  <el-input v-model="post.longitude"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24" v-if="isPromoteur">
                <el-form-item :label="$labels.bureau_vente_adresse">
                  <el-input :rows="5" type="textarea" v-model="post.bureau_vente_adresse"></el-input>
                </el-form-item>
              </el-col>
              <!--							<el-col :span="12" v-if="isCmiste == false">-->
              <el-col :span="10">
                <el-form-item style="font-weight: bold;" prop="communiquer_adresse_exacte">
                  <strong>{{ $labels.communiquer_adresse_exacte }} *</strong>
                  <div style="margin-top: -40px; margin-left: 250px;">
                    <el-tooltip class="item" effect="dark" :content="$t('posts.edit.exactAddressTooltip')"
                                placement="bottom">
                      <em class="el-icon-question"></em>
                    </el-tooltip>
                  </div>
                  <el-radio-group v-model="post.communiquer_adresse_exacte">
                    <el-radio label="oui" value="oui">{{ $t("general.yes") }}</el-radio>
                    <el-radio label="non" value="non">{{ $t("general.no") }}</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>

              <!--							<el-col :span="12" v-if="isCmiste == false">-->
              <!--              <el-col :span="12">-->
              <!--                  <el-tooltip placement="top-start" :content="$t('posts.edit.exactAddressTooltip')">-->
              <!--                    <em class="el-icon-question"></em>-->
              <!--                  </el-tooltip>-->
              <!--              </el-col>-->
            </el-row>

            <!--						<div v-if="post.communiquer_adresse_exacte === 'non' || isCmiste">-->
            <div v-if="post.communiquer_adresse_exacte === 'non'">
              <el-col :span="24">
                <hr/>
              </el-col>
              <el-row v-if="isCmiste">
                <el-col :span="8">
                  <h4>{{ $t("posts.edit.locationToPublishTitle") }}
                    <el-tooltip placement="top-start" :content="$t('posts.edit.locationToPublishTooltip')">
                      <em class="el-icon-question"></em>
                    </el-tooltip>
                  </h4>
                  <br>
                </el-col>
              </el-row>
              <el-row v-else>
                <el-col :span="24">
                  <h4>{{ $t("posts.edit.locationToPublishTitle") }}</h4>
                  <br>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :md="12" :xs="24">
                  <el-form-item :label="$labels.code_postal + ' *'" prop="code_postal">
                    <el-autocomplete
                        class="inline-input"
                        v-model="post.code_postal"
                        :fetch-suggestions="searchPostal"
                        @select="selectPostal"></el-autocomplete>
                  </el-form-item>
                </el-col>
                <el-col :md="12" :xs="24">
                  <el-form-item :label="$labels.ville + ' *'" prop="ville">
                    <el-input v-model="post.ville"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :md="24" :xs="24">
                  <el-form-item label="Secteur" prop="secteur">
                    <el-input v-model="post.zone_geo"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </el-main>
        </el-container>
      </ubi-panel>
      <!--PROMOTEUR PROGRAMME-->
      <div v-if="isPromoteur && !filter.annonceParente">
        <ubi-panel>
          <el-container>
            <el-aside width="30%">
              <h3>{{ $t("posts.edit.saleDetailsTitle") }}</h3>
            </el-aside>
            <el-main>
              <el-row :gutter="20">
                <el-col :span="24">
                  <div class="block">
                    <el-form-item :label="$labels.date_commercialisation">
                      <el-date-picker format="dd/MM/yyyy"
                                      value-format="dd/MM/yyyy"
                                      v-model="post.date_commercialisation"></el-date-picker>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="block">
                    <el-form-item :label="$labels.date_livraison">
                      <el-date-picker format="dd/MM/yyyy"
                                      value-format="dd/MM/yyyy"
                                      v-model="post.date_livraison"></el-date-picker>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="block">
                    <el-form-item :label="$labels.date_debut_travaux">
                      <el-date-picker format="dd/MM/yyyy"
                                      value-format="dd/MM/yyyy"
                                      v-model="post.date_debut_travaux"></el-date-picker>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="24">
                  <el-form-item>
                    <el-col :span="10">
                      <el-checkbox v-model="post.avant_premiere" false-label="non" true-label="oui">
                        {{ $labels.avant_premiere }}
                      </el-checkbox>
                    </el-col>
                    <el-col :span="10">
                      <el-checkbox v-model="post.lancement_commercial" false-label="non" true-label="oui">
                        {{ $labels.lancement_commercial }}
                      </el-checkbox>
                    </el-col>
                    <el-col :span="10">
                      <el-checkbox v-model="post.travaux_en_cours" false-label="non" true-label="oui">
                        {{ $labels.travaux_en_cours }}
                      </el-checkbox>
                    </el-col>
                    <el-col :span="10">
                      <el-checkbox v-model="post.derniere_opportunite" false-label="non" true-label="oui">
                        {{ $labels.derniere_opportunite }}
                      </el-checkbox>
                    </el-col>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="Livraison">
                    <el-checkbox false-label="non" true-label="oui" v-model="post.livraison_immediate">
                      {{ $labels.livraison_immediate }}
                    </el-checkbox>
                    <el-checkbox false-label="non" true-label="oui" v-model="post.tranche_1">
                      {{$labels.tranche_1}}
                    </el-checkbox>
                    <el-checkbox false-label="non" true-label="oui" v-model="post.tranche_2">
                      {{$labels.tranche_2}}
                    </el-checkbox>
                  </el-form-item>
                </el-col>
                <el-col :span="24" style="margin-bottom: 15px">
                  {{ $t("posts.edit.target") }}
                </el-col>
                <el-col :span="24">
                  <el-checkbox false-label="non" true-label="oui" v-model="post.pour_investisseur">
                    {{ $labels.pour_investisseur }}
                  </el-checkbox>
                  <el-checkbox false-label="non" true-label="oui" v-model="post.pour_habiter">
                    {{ $labels.pour_habiter }}
                  </el-checkbox>
                  <el-checkbox false-label="non" true-label="oui" v-model="post.prestige">
                    {{ $labels.prestige }}
                  </el-checkbox>
                </el-col>
              </el-row>
            </el-main>
          </el-container>
        </ubi-panel>

        <ubi-panel>
          <ubi-form-group :title="$t('posts.offerTitle')">
            <el-row :gutter="20">
              <el-col :span="15">
                <el-form-item :label="$labels.offre_titre" prop="offre_titre">
                  <el-input :placeholder="$t('validator.offerTitleMax', {number: 70})"
                            v-model.number="post.offre_titre"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <div></div>
              </el-col>
              <el-col :span="24">
                <el-form-item :label="$t('posts.offerDetail')">
                  <el-input
                      :rows="2"
                      type="textarea"
                      v-model="post.offre_texte"
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="24">
                <el-form-item :label="$labels.offre_mentions_legales">
                  <el-input v-model.number="post.offre_mentions_legales"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item :label="$labels.offre_type">
                  <el-input v-model.number="post.offre_type" :disabled="desactiverChamp"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <div class="block">
                  <el-form-item :label="$labels.offre_date_de_debut">
                    <el-date-picker format="dd/MM/yyyy"
                                    value-format="dd/MM/yyyy" v-model="post.offre_date_debut"></el-date-picker>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="block">
                  <el-form-item :label="$labels.offre_date_de_fin">
                    <el-date-picker format="dd/MM/yyyy"
                                    value-format="dd/MM/yyyy" v-model="post.offre_date_fin"></el-date-picker>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </ubi-form-group>
        </ubi-panel>
        <defisc :post="post"></defisc>
      </div>
      <!--PROMOTEUR LOT-->
      <div v-else-if="(isPromoteur || isBailleurSocial) && filter.annonceParente">
        <ubi-panel v-if="post.annonce_parente_type_objet != 3300">
          <ubi-form-group :title="$t('posts.energyTitle')">
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item>
                  <div style="font-size: 12px;">{{$labels.chauffage_type}}
                    <el-button @click="post.chauffage_type = null"
                               circle
                               class="el-icon-error reset-radio"
                               v-if="post.chauffage_type != '' && post.chauffage_type != undefined && post.chauffage_type != null"/>
                  </div>
                  <el-radio-group v-model="post.chauffage_type" @change="changeForLot('chauffage_type')"
                                  :value="valueChangeLot">
                    <el-radio
                        :label="energieChauffageChoice"
                        :value="energieChauffageChoice"
                        v-for="energieChauffageChoice in this.getChoices('chauffage_type')">
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item :label="$labels.chauffage_energie">
                  <el-select
                      v-model="post.chauffage_energie"
                      :placeholder="$t('posts.edit.selectTypePlaceholder')"
                      clearable
                      filterable
                      @change="changeForLot('chauffage_energie')" :value="valueChangeLot"
                  >
                    <el-option
                        :label="energieChauffageChoice"
                        :value="energieChauffageChoice"
                        v-for="energieChauffageChoice in this.getChoices('chauffage_energie')"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item>
                  <div style="font-size: 12px;">{{ $labels.eau_chaude_distribution}}
                    <el-button @click="post.eau_chaude_distribution = null"
                               circle
                               class="el-icon-error reset-radio"
                               v-if="post.eau_chaude_distribution != '' && post.eau_chaude_distribution != undefined && post.eau_chaude_distribution != null"/>
                  </div>
                  <el-radio-group v-model="post.eau_chaude_distribution"
                                  @change="changeForLot('eau_chaude_distribution')" :value="valueChangeLot">
                    <el-radio
                        :label="eauChaudeDistributionChoice"
                        :value="eauChaudeDistributionChoice"
                        v-for="eauChaudeDistributionChoice in this.getChoices('eau_chaude_distribution')">
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
          </ubi-form-group>
        </ubi-panel>
        <dpe-ges :post="post" v-if="post.annonce_parente_type_objet != 3300"></dpe-ges>
        <ubi-panel>
          <ubi-form-group :title="$t('posts.exteriorTitle')">
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item
                    :label="$labels.surface_terrain"
                    prop="surface_terrain"
                >
                  <el-input type="surface_terrain" v-model.number="post.surface_terrain"
                            @input="changeForLot('surface_terrain')" :value="valueChangeLot">
                    <div slot="append">m²</div>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                    :rules="[
												{ type: 'number', message: this.$t('validator.mustBeNumericValue')}
										  ]"
                    :label="$labels.nb_parkings"
                    prop="nb_parkings"

                >
                  <el-input type="nb_parking" v-model.number="post.nb_parkings" @input="changeForLot('nb_parkings')"
                            :value="valueChangeLot"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                    :rules="[
												{ type: 'number', message: this.$t('validator.mustBeNumericValue')}
										  ]"
                    :label="$labels.nb_garages"
                    prop="nb_garages"
                >
                  <el-input type="nb_garages" v-model.number="post.nb_garages" @input="changeForLot('nb_garages')"
                            :value="valueChangeLot"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item :label="$labels.exposition">
                  <el-select
                      v-model="post.exposition"
                      :placeholder="$t('posts.edit.selectTypePlaceholder')"
                      clearable
                      filterable
                      @change="changeForLot('exposition')" :value="valueChangeLot">
                    <el-option
                        :label="expositionChoice"
                        :value="expositionChoice"
                        v-for="expositionChoice in this.getChoices('exposition')"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item
                    :rules="[
												{ type: 'number', message: this.$t('validator.mustBeNumericValue')}
										  ]"
                    :label="$labels.terrasse_surface"
                    prop="terrasse_surface"
                >
                  <el-input type="terrasse_surface" v-model.number="post.terrasse_surface"
                            @input="changeForLot('terrasse_surface')" :value="valueChangeLot">
                    <div slot="append">m²</div>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                    :rules="[
												{ type: 'number', message: this.$t('validator.mustBeNumericValue')}
										  ]"
                    :label="$labels.surface_cave"
                    prop="surface_cave"
                >
                  <el-input type="surface_cave" v-model.number="post.surface_cave" @input="changeForLot('surface_cave')"
                            :value="valueChangeLot">
                    <div slot="append">m²</div>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12" v-if="post.balcon == 'oui'">
                <el-form-item
                    :rules="[
												{ type: 'number', message: this.$t('validator.mustBeNumericValue')}
										  ]"
                    :label="$labels.nb_balcons"
                    prop="nb_balcons"
                >
                  <el-input type="nb_balcons" v-model.number="post.nb_balcons" @input="changeForLot('nb_balcons')"
                            :value="valueChangeLot"/>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="post.balcon == 'oui'">
                <el-form-item
                    :rules="[
												{ type: 'number', message: this.$t('validator.mustBeNumericValue')}
										  ]"
                    :label="$labels.surface_balcon"
                    prop="surface_balcon"
                >
                  <el-input type="surface_balcon" v-model.number="post.surface_balcon">
                    <div slot="append">m²</div>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item :title="$t('posts.edit.exteriorServices')">
                  <el-checkbox v-model="post.ascenseur" true-label="oui" false-label="non">
                    {{$labels.ascenseur}}
                  </el-checkbox>
                  <el-checkbox false-label="non" true-label="oui" v-model="post.terrasse"
                               @change="changeCheckboxLot('terrasse')" :checked="isChecked">
                    {{ $labels.terrasse }}
                  </el-checkbox>
                  <el-checkbox v-model="post.balcon" true-label="oui" false-label="non"
                               @change="changeCheckboxLot('balcon')" :checked="isChecked">
                    {{ $labels.balcon }}
                  </el-checkbox>
                  <el-checkbox false-label="non" true-label="oui" v-model="post.garage"
                               @change="changeCheckboxLot('garage')" :checked="isChecked">
                    {{ $labels.garage }}
                  </el-checkbox>
                  <el-checkbox false-label="non" true-label="oui" v-model="post.possede_parking"
                               @change="changeCheckboxLot('possede_parking')" :checked="isChecked">
                    {{$labels.possede_parking}}
                  </el-checkbox>
                  <el-checkbox false-label="non" true-label="oui" v-model="post.possede_box"
                               @change="changeCheckboxLot('possede_box')" :checked="isChecked">
                    {{$labels.possede_box}}
                  </el-checkbox>
                  <el-checkbox false-label="non" true-label="oui" v-model="post.cave"
                               @change="changeCheckboxLot('cave')" :checked="isChecked">
                    {{ $labels.cave }}
                  </el-checkbox>
                  <el-checkbox false-label="non" true-label="oui" v-model="post.avec_jardin"
                               @change="changeCheckboxLot('avec_jardin')" :checked="isChecked">
                    {{$labels.avec_jardin}}
                  </el-checkbox>
                  <el-checkbox false-label="non" true-label="oui" v-model="post.avec_toit_terrasse"
                               @change="changeCheckboxLot('avec_toit_terrasse')" :checked="isChecked">
                    {{$labels.avec_toit_terrasse}}
                  </el-checkbox>
                  <el-checkbox false-label="non" true-label="oui" v-model="post.digicode"
                               @change="changeCheckboxLot('digicode')" :checked="isChecked">
                    {{ $labels.digicode }}
                  </el-checkbox>
                  <el-checkbox false-label="non" true-label="oui" v-model="post.interphone"
                               @change="changeCheckboxLot('interphone')" :checked="isChecked">
                    {{ $labels.interphone }}
                  </el-checkbox>
                  <el-checkbox false-label="non" true-label="oui" v-model="post.videophone"
                               @change="changeCheckboxLot('videophone')" :checked="isChecked">
                    {{ $labels.videophone }}
                  </el-checkbox>
                  <el-checkbox false-label="non" true-label="oui" v-model="post.alarme_habitation"
                               @change="changeCheckboxLot('alarme_habitation')" :checked="isChecked">
                    {{ $labels.alarme_habitation }}
                  </el-checkbox>
                  <el-checkbox false-label="non" true-label="oui" v-model="post.gardien"
                               @change="changeCheckboxLot('gardien')" :checked="isChecked">
                    {{ $labels.gardien }}
                  </el-checkbox>
                  <el-checkbox false-label="non" true-label="oui" v-model="post.piscine"
                               @change="changeCheckboxLot('piscine')" :checked="isChecked">
                    {{ $labels.piscine }}
                  </el-checkbox>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item :label="$t('posts.environmentTitle')">
                  <el-checkbox false-label="non" true-label="oui" v-model="post.belle_vue"
                               @change="changeCheckboxLot('belle_vue')" :checked="isChecked">
                    {{ $labels.belle_vue }}
                  </el-checkbox>
                  <el-checkbox false-label="non" true-label="oui" v-model="post.vue_sur_mer"
                               @change="changeCheckboxLot('vue_sur_mer')" :checked="isChecked">
                    {{ $labels.vue_sur_mer }}
                  </el-checkbox>
                  <el-checkbox false-label="non" true-label="oui" v-model="post.est_calme"
                               @change="changeCheckboxLot('est_calme')" :checked="isChecked">
                    {{ $labels.est_calme}}
                  </el-checkbox>
                  <el-checkbox false-label="non" true-label="oui" v-model="post.avec_vis_a_vis"
                               @change="changeCheckboxLot('avec_vis_a_vis')" :checked="isChecked">
                    {{ $labels.avec_vis_a_vis}}
                  </el-checkbox>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20" v-if="post.avec_jardin == 'oui'">
              <el-col :span="24">
                <el-form-item
                    :rules="[{ type: 'number', message: this.$t('validator.mustBeNumericValue')}]"
                    :label="$labels.surface_jardin"
                    prop="surface_jardin"
                >
                  <el-input type="surface_jardin" v-model.number="post.surface_jardin"
                            @input="changeForLot('surface_jardin')" :value="valueChangeLot">
                    <div slot="append">m²</div>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24" style="margin-top: 30px">
                <el-form-item
                    :label="$labels.type_jardin"
                    prop="type_jardin"

                >
                  <el-radio-group v-model="post.type_jardin" @input="changeForLot('type_jardin')"
                                  :value="valueChangeLot">
                    <el-radio
                        :label="jardinChoice"
                        :value="jardinChoice"
                        v-for="jardinChoice in this.getChoices('type_jardin')">
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
          </ubi-form-group>
        </ubi-panel>
      </div>
      <defisc :post="post" v-if="isBailleurSocial"></defisc>
      <ubi-panel>
        <PostFormContactInfo :post="post" :id-user="idUser"/>
      </ubi-panel>
      <PostFormAttachedUser :post="post" :id-user="idUser"/>
    </div>

    <div v-show="currentTab === 'detail'">
      <component :ddList.sync="ddList" @ddList-update="ddListUpdated" :is="selectTypeOffreComponent()" :post="post"
                 :disableLocSaisonniere="disableLocSaisonniere"/>
    </div>

    <div v-show="currentTab === 'description'">
      <component :ddList.sync="ddList" @ddList-update="ddListUpdated" :is="selectTypeObjetComponent()" :post="post" v-on:check-jardin="checkJardin()"/>
    </div>

    <div v-show="currentTab === 'medias'">
      <ubi-panel>
        <PostFormGroupPhotos/>
        <PostImagesUpload :post="post" :desactiverChamp="mediaUploadDisabled"/>
      </ubi-panel>

      <PostOtherMediaUpload :post="post" :desactiverChamp="mediaUploadDisabled"/>

    </div>

    <div v-show="currentTab === 'mentions_legales'">
      <PostFormMentionsLegalesSelect :post="post"/>
    </div>

    <div v-show="currentTab === 'international'">
      <ubi-panel>
        <ubi-form-group :title="$t('posts.edit.internationalTitle')">
          <el-col :span="24">
            <el-form-item :label="$labels.titre_anglais">
              <el-input v-model="post.titre_anglais"/>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item :label="$labels.texte_anglais">
              <el-input :rows="5" type="textarea" v-model="post.texte_anglais"/>
            </el-form-item>
          </el-col>
        </ubi-form-group>
      </ubi-panel>
    </div>

    <div v-show="currentTab === 'parametres'">
      <PostFormVisite :post="post"/>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex'
import {
  duplicateFromParent,
  getDefinitionDonneeListeeByCode,
  getPostById,
  getPosts,
  checkedPromoteurLot,
  mergePost,
  duplicatePost,
  updatePost,
  flatPost,
  patchPost
} from '../../../services/posts'
import UbiPanel from '@/components/Panel'
import UbiCardContainer from '@/components/CardContainer'
import UbiCard from '@/components/Card'
import PostFormObjectType from '../components/PostFormObjectType'
import PostFormOfferType from '../components/PostFormOfferType'
import PostFormGroupPhotos from '../components/PostFormGroupPhotos'
import PostImagesUpload from '../components/PostImagesUpload'
import PostEditImmoObject11 from '../forms/immo/PostEditImmoObject1100'
import PostEditImmoObject12 from '../forms/immo/PostEditImmoObject1200'
import PostEditImmoObject1200CmiModel from '../forms/immo/PostEditImmoObject1200CmiModel'
import PostEditImmoObject13 from '../forms/immo/PostEditImmoObject1300'
import PostEditImmoObject14 from '../forms/immo/PostEditImmoObject1400'
import PostEditImmoObject15 from '../forms/immo/PostEditImmoObject1500'
import PostEditImmoObject21 from '../forms/immo/PostEditImmoObject2100'
import PostEditImmoObject22 from '../forms/immo/PostEditImmoObject2200'
import PostEditImmoObject23 from '../forms/immo/PostEditImmoObject2300'
import PostEditImmoObject24 from '../forms/immo/PostEditImmoObject2400'
import PostEditImmoObject31 from '../forms/immo/PostEditImmoObject3100'
import PostEditImmoObject32 from '../forms/immo/PostEditImmoObject3200'
import PostEditImmoObject33 from '../forms/immo/PostEditImmoObject3300'
import PostEditImmoObject34 from '../forms/immo/PostEditImmoObject3400'
import PostEditImmoObject35 from '../forms/immo/PostEditImmoObject3500'
import PostEditImmoObject41 from '../forms/immo/PostEditImmoObject4100'
import PostEditImmoObject42 from '../forms/immo/PostEditImmoObject4200'
import PostEditImmoObject43 from '../forms/immo/PostEditImmoObject4300'
import PostEditImmoObject52 from '../forms/immo/PostEditImmoObject5200'
import PostEditImmoObject1310 from '../forms/immo/PostEditImmoObject1310'
import PostEditImmoObject1310CmiModel from '../forms/immo/PostEditImmoObject1310CmiModel'
import PostEditImmoOfferA from '../forms/immo/PostEditImmoOfferA'
import PostEditImmoOfferB from '../forms/immo/PostEditImmoOfferB'
import PostEditImmoOfferF from '../forms/immo/PostEditImmoOfferF'
import PostEditImmoOfferG from '../forms/immo/PostEditImmoOfferG'
import PostEditImmoOfferH from '../forms/immo/PostEditImmoOfferH'
import PostEditImmoOfferI from '../forms/immo/PostEditImmoOfferI'
import PostEditImmoOfferL from '../forms/immo/PostEditImmoOfferL'
import PostEditImmoOfferM from '../forms/immo/PostEditImmoOfferM'
import PostEditImmoOfferS from '../forms/immo/PostEditImmoOfferS'
import PostEditImmoOfferV from '../forms/immo/PostEditImmoOfferV'
import PostEditImmoOfferW from '../forms/immo/PostEditImmoOfferW'
import PostEditImmoOfferZ from '../forms/immo/PostEditImmoOfferZ'
import PostFormMentionsLegalesSelect from '../forms/immo/PostFormMentionsLegalesSelect'
import PostFormMentionsLegalesCreate from '../forms/immo/PostFormMentionsLegalesCreate'
import PostFormMentionsLegalesManage from '../forms/immo/PostFormMentionsLegalesManage'
import PostFormImmoSurfaceMainTab from '@/pages/posts/forms/immo/PostFormImmoSurfaceMainTab'
import ElButton from '../../../components/Button'
import { getCodePostalVille } from '../../../services/toolbox'
import PostOtherMediaUpload from '../components/PostOtherMediaUpload'
import _find from 'lodash/find'
import { getUsers } from '@/services/users'
import PostFormContactInfo from '../components/PostFormContactInfo'
import PostFormAttachedUser from '../components/PostFormAttachedUser'
import DpeGes from '../forms/Block/DpeGes'
import Defisc from '@/pages/posts/forms/Block/Defisc'
import PostFormVisite from '@/pages/posts/forms/immo/PostFormVisite'
import _findIndex from 'lodash/findIndex'
import SecuriteBien from '@/pages/posts/forms/Block/SecuriteBien.vue'

export default {
  name: 'PostEditImmo',
  props: ['currentTab', 'create', 'post', 'redirect', 'idUser'],
  // DO NOT FORGET TO REGISTERS OBJECT AND OFFER COMPONENTS, OTHERWHISE THIS WILL NOT WORK
  components: {
    SecuriteBien,
    PostOtherMediaUpload,
    ElButton,
    PostEditImmoObject11,
    PostEditImmoObject12,
    PostEditImmoObject1200CmiModel,
    PostEditImmoObject13,
    PostEditImmoObject14,
    PostEditImmoObject15,
    PostEditImmoObject21,
    PostEditImmoObject22,
    PostEditImmoObject23,
    PostEditImmoObject24,
    PostEditImmoObject31,
    PostEditImmoObject32,
    PostEditImmoObject33,
    PostEditImmoObject34,
    PostEditImmoObject35,
    PostEditImmoObject41,
    PostEditImmoObject42,
    PostEditImmoObject43,
    PostEditImmoObject52,
    PostEditImmoObject1310,
    PostEditImmoObject1310CmiModel,
    PostEditImmoOfferA,
    PostEditImmoOfferB,
    PostEditImmoOfferF,
    PostEditImmoOfferG,
    PostEditImmoOfferH,
    PostEditImmoOfferI,
    PostEditImmoOfferL,
    PostEditImmoOfferM,
    PostEditImmoOfferS,
    PostEditImmoOfferV,
    PostEditImmoOfferW,
    PostEditImmoOfferZ,
    PostImagesUpload,
    PostFormGroupPhotos,
    PostFormOfferType,
    PostFormObjectType,
    UbiCard,
    UbiCardContainer,
    UbiPanel,
    PostFormMentionsLegalesCreate,
    PostFormMentionsLegalesManage,
    PostFormMentionsLegalesSelect,
    PostFormContactInfo,
    PostFormAttachedUser,
    PostFormImmoSurfaceMainTab,
    DpeGes,
    Defisc,
    PostFormVisite
  },
  inject: ['browserContext'],

  data () {
    return {
      choixCommercialisation: '',
      tabs: [
        { name: 'main', title: this.$t('posts.edit.tabMain') },
        { name: 'detail', title: this.$t('posts.edit.tabDetail'), disabled: true },
        { name: 'description', title: this.$t('posts.edit.tabDescription'), disabled: true },
        { name: 'medias', title: this.$t('posts.edit.tabMedias') },
        { name: 'mentions_legales', title: this.$t('posts.edit.tabLegalNotices') },
        { name: 'international', title: this.$t('posts.edit.tabInternational') }
      ],
      tabsBis: [
        { name: 'main', title: this.$t('posts.edit.tabMain') },
        { name: 'detail', title: this.$t('posts.edit.tabDetail'), disabled: true },
        { name: 'description', title: this.$t('posts.edit.tabDescription'), disabled: true },
        { name: 'medias', title: this.$t('posts.edit.tabMedias') },
        { name: 'mentions_legales', title: this.$t('posts.edit.tabLegalNotices') },
        { name: 'international', title: this.$t('posts.edit.tabInternational') }
      ],
      tabsProgramme: [
        { name: 'main', title: this.$t('posts.edit.tabMain') },
        { name: 'description', title: this.$t('posts.edit.tabDetailProgram'), disabled: true },
        { name: 'medias', title: this.$t('posts.edit.tabMedias') },
        { name: 'mentions_legales', title: this.$t('posts.edit.tabLegalNotices') },
        { name: 'international', title: this.$t('posts.edit.tabInternational') }
      ],
      tabsLot: [
        { name: 'main', title: this.$t('posts.edit.tabMain') },
        { name: 'medias', title: this.$t('posts.edit.tabMedias') },
        { name: 'mentions_legales', title: this.$t('posts.edit.tabLegalNotices') },
        { name: 'international', title: this.$t('posts.edit.tabInternational') }
      ],
      tabsModele: [
        { name: 'main', title: this.$t('posts.edit.tabMain') },
        { name: 'detail', title: this.$t('posts.edit.tabDetail'), disabled: true },
        { name: 'description', title: this.$t('posts.edit.tabDescription'), disabled: false },
        { name: 'medias', title: this.$t('posts.edit.tabMedias') },
        { name: 'mentions_legales', title: this.$t('posts.edit.tabLegalNotices') },
        { name: 'international', title: this.$t('posts.edit.tabInternational') }
      ],
      nomProgram: '',
      ddList: [],
      parent: null,
      codesPostaux: [],
      paysValue: null,
      desactiverChamp: false,
      desactiverTexte: false,
      desactiverTitre: false,
      modalCmisteModelDisabled: true,
      desactivationCmiModele: false,
      checkedList: [],
      valueChange: '',
      valueDevise: '',
      chargementDonnees: true,
      selectTerrainCmisteModele: null,
      selectModeleCmiste: null,
      currentLandId: null,
      currentModelId: null,
      currentLand: null,
      currentModel: null,
      currentProgramId: null,
      listeTerrains: null,
      listeModeles: null,
      modalShowModels: false,
      modeleCMI5200: false,
      loadingCMIcreatePost: false,
      tailleSelectPopup: 24,
      referenceDupli: null,
      listeProgramModeles: null,
      labelModeleTerrain: '',
      disableLocSaisonniere: false,
      isProgramBailleur: false,
      isPaysMaurice: false,
      checkedChargeIncluded: false
    }
  },
  watch: {
    post: {
      handler (newPost) {
        if (newPost.avec_jardin === 'non') {
          this.$set(this.post, 'surface_jardin', null)
          this.$set(this.post, 'type_jardin', null)
        }
      },
      deep: true
    }
  },
  methods: {
    ...mapMutations('posts', ['setTabs']),
    ...mapMutations('postEditImmo', ['setAdManagerChanged', 'SET_MEDIA_UPLOAD_DISABLED']),
    handleTexte () {
      if (this.post.sourceCode &&
          (this.post.sourceCode.search('SAISIE') === -1) &&
          (this.post.localText != this.post.texte) &&
          this.sitimmoUser.betaTesteur) {
        this.post.texte_long = this.post.localText
        this.post.texte = this.post.texte_court
      } else {
        this.post.texte = this.post.localText
        delete this.post.texte_long
      }
    },
    changeCheckboxLot (val) {
      this.valueChange = val
      if (this.post[val] == 'oui') {
        this.checkedList[val] = true
      } else {
        this.checkedList[val] = false
      }
      if (this.post.avec_jardin === 'non') {
        delete (this.post.type_jardin)
      }
    },
    changeForLot (val) {
      this.valueChange = this.post[val]
    },
    disableChampsLocSaisonniere () {
      if (this.post.typeOffre == 'S') {
        if (this.post.afficher_prix == 'non') {
          this.disableLocSaisonniere = true
        } else {
          this.disableLocSaisonniere = false
        }
      }
    },
    setLocSaisonnierePrix () {
      this.post.tarif_hebdo_basse_saison = this.post.prix
    },
    selectTypeObjetComponent () {
      const indexTypeOffre = _findIndex(this.tabs, function (o) { return o.name === 'detail' })
      const indexTypeObjet = _findIndex(this.tabs, function (o) { return o.name === 'description' })
      // Cas d'un modèle Programme + maison
      if (this.isCmiste && this.post && this.post.id !== null && this.post.etat === 'M' && this.post.typeObjet === '5200') {
        this.modeleCMI5200 = true
        this.tabs = this.tabsBis
        this.setTabs(this.tabs)
        if (indexTypeOffre && this.tabs[indexTypeOffre]) {
          this.tabs[indexTypeOffre].disabled = false
        }
        if (indexTypeObjet && this.tabs[indexTypeObjet]) {
          this.tabs[indexTypeObjet].disabled = false
        }
        return 'PostEditImmoObject52'
      } else if (this.post.typeObjet) {
        if (this.post.typeObjet >= 2000 && this.post.typeObjet < 3000) {
          this.$emit('change-city-rule', { mandatoryCity: false })
        } else {
          this.$emit('change-city-rule', { mandatoryCity: true })
        }
        if (indexTypeOffre && this.tabs[indexTypeOffre]) {
          this.tabs[indexTypeOffre].disabled = false
        }
        if (indexTypeObjet && this.tabs[indexTypeObjet]) {
          this.tabs[indexTypeObjet].disabled = false
        }
        const component = 'PostEditImmoObject' + Math.trunc(this.post.typeObjet / 100)
        if (this.$options.components[component]) {
          return component
        } else if (this.post && this.post.etat === 'M' && this.isCmiste) {
          this.tabs[2].disabled = true
        }
      } else {
        this.tab = this.tabsModele
      }
      return null
    },
    typeChange (event, ...args) {
      this.$emit('check-rules-surface', this.post.typeObjet)
    },
    checkModelCmisteButton () {
      // Cas 1 Programmes Avec programmes terrain + maison
      // Cas 2 Terrain + maison avec Programme T+M
      // Cas 4 Terrain avec terrain
      if (this.post.typeObjet === 5200) {
        if (this.currentProgramId && (this.currentLandId || this.currentModelId)) {
          this.modalCmisteModelDisabled = true
        } else if (this.currentProgramId) {
          this.modalCmisteModelDisabled = false
        } else if (this.currentLandId && this.currentModelId) {
          this.modalCmisteModelDisabled = false
        } else if (!this.currentLandId && this.currentModelId) {
          this.modalCmisteModelDisabled = false
        } else {
          this.modalCmisteModelDisabled = true
        }
      } else if (this.currentLandId && this.post.typeObjet === 1310) {
        this.modalCmisteModelDisabled = false
      } else {
        this.modalCmisteModelDisabled = true
      }
    },
    async fetchDataModelsCmiste () {
      if (this.post.typeObjet === 1310) {
        this.labelModeleTerrain = this.$t('posts.dialog.selectTerrain') + ' *'
        this.loadingCMIcreatePost = true
        this.tailleSelectPopup = 24
        this.selectTerrainCmisteModele = true
        this.selectModeleCmiste = false
        this.listeTerrains = await getPosts({ typeObjets: 1300, annoncesModeles: true, limit: 200 })
        this.loadingCMIcreatePost = false
      } else if (this.post.typeObjet == 5200) {
        this.labelModeleTerrain = this.$t('posts.dialog.selectTerrain')
        this.loadingCMIcreatePost = true
        this.tailleSelectPopup = 12
        this.selectModeleCmiste = true
        this.selectTerrainCmisteModele = true
        this.listeTerrains = await getPosts({ typeObjets: 1300, annoncesModeles: true, limit: 200 })
        this.listeModeles = await getPosts({ typeObjets: 1200, annoncesModeles: true, limit: 200 })
        this.listeProgramModeles = await getPosts({ typeObjets: 5200, annoncesModeles: true, limit: 200 })
        this.loadingCMIcreatePost = false
      }
      this.$emit('check-rules-surface', this.post.typeObjet)
    },
    async mergePosts () {
      this.loadingCMIcreatePost = true
      const reference = this.referenceDupli
      let generatedPost = null
      this.$emit('change-redirect', true)
      this.loading = true
      if (this.post.typeObjet === 1310) {
        generatedPost = await duplicatePost(this.currentLandId, reference)
        if (!generatedPost.reference) {
          this.$message({ message: this.$t('validator.referenceAlreadyExists'), type: 'error' })
        } else if (generatedPost.type === 'error') {
          this.$message({ message: this.$t('error.found'), type: 'error' })
          this.loading = false
          this.loadingCMIcreatePost = false
          return false
        }
      }
      if (this.post.typeObjet === 5200) {
        let currentId = -1
        if (this.currentLandId && this.currentModelId) {
          generatedPost = await mergePost(this.currentLandId, this.currentModelId, reference)
          if (!generatedPost.reference) {
            this.$message({ message: this.$t('validator.referenceAlreadyExists'), type: 'error' })
          } else if (generatedPost.type == 'error') {
            this.$message({ message: this.$t('error.found'), type: 'error' })
            this.loading = false
            this.loadingCMIcreatePost = false
            return false
          }
        } else if (!this.currentLandId && this.currentModelId) {
          currentId = this.currentModelId
        } else if (this.currentProgramId) {
          currentId = this.currentProgramId
        }
        if (currentId !== -1) {
          generatedPost = await duplicatePost(currentId, reference)
          if (!generatedPost.reference) {
            this.$message({ message: this.$t('validator.referenceAlreadyExists'), type: 'error' })
          } else if (generatedPost.type == 'error') {
            this.$message({ message: this.$t('error.found'), type: 'error' })
            this.loading = false
            this.loadingCMIcreatePost = false
            return false
          }
        }
      }
      if (generatedPost.id != null) {
        const newPost = await getPostById(generatedPost.id)
        if (this.currentLandId && this.currentModelId) {
          const previousLand = await getPostById(this.currentLandId)
          const previousModel = await getPostById(this.currentModelId)
          newPost.texte = previousModel.texte + '\r\n\r\n' + previousLand.texte
          newPost.prix = previousLand.prix + previousModel.prix
          newPost.prix_terrain = previousLand.prix
          newPost.code_type_objet = '5200'
        } else if (!this.currentLandId && this.currentModelId) {
          const previousModel = await getPostById(this.currentModelId)
          newPost.texte = previousModel.texte
          newPost.prix = previousModel.prix
          newPost.ville_reelle = this.sitimmoUser.ville
          newPost.code_postal_reel = this.sitimmoUser.codePostal
          newPost.ville = this.sitimmoUser.ville
          newPost.code_postal = this.sitimmoUser.codePostal
          newPost.communiquer_adresse_exacte = true
          newPost.prix = previousModel.prix
          newPost.code_type_objet = '5200'
        }
        if (this.currentLandId && !this.currentModelId) {
          newPost.code_type_objet = '1310'
        } else {
          newPost.code_type_objet = '5200'
        }
        newPost.STATUS = 'B'
        const resp = await patchPost(newPost, this.sitimmoLogin, 'SAISIE_IMMO')
        if (resp.type == 'error') {
          this.$message({ message: this.$t('error.found'), type: 'error' })
          this.loading = false
          this.loadingCMIcreatePost = false
          return false
        }
        this.$router.push({
          name: 'post-edit',
          params: { id: newPost.id },
          query: { saisie: 'SAISIE_IMMO' }
        })
      }
      this.loadingCMIcreatePost = false
    },
    cancelMerge () {
      this.modalShowModels = false
      this.currentModelId = null
      this.currentLandId = null
      this.referenceDupli = null
    },
    async searchPostal (queryString, cb) {
      if (!this.post.localiser_sur_departement || this.post.localiser_sur_departement === 'non') {
        let loadedPays = this.paysValue
        if (this.post.pays) {
          loadedPays = this.post.pays
        }
        const results = await getCodePostalVille(queryString, loadedPays)
        if (results.type == 'error') {
          this.$message({ message: this.$t('error.found'), type: 'error' })
          this.loading = false
          return false
        }
        const tab = Object.values(results.result)
        cb(tab)
      }
    },
    addTerrain () {
      const landId = this.currentLandId
      let land = null
      this.listeTerrains.list.forEach(function (item) {
        if (landId == item.id) {
          land = item
        }
      })
      this.currentLand = land
      this.integrateLandOrModel()
    },
    addModel () {
      const modelId = this.currentModelId
      let model = null
      this.listeModeles.list.forEach(function (item) {
        if (modelId == item.id) {
          model = item
        }
      })
      this.currentModel = model
      this.integrateLandOrModel()
    },
    integrateLandOrModel () {
      this.modalShowModels = true
    },
    selectPays (item) {
      this.post.pays = item
      if (item === 'Maurice' || item === 'Mauritius' || item === 'Mauricio') {
        this.isPaysMaurice = true
      } else {
        this.isPaysMaurice = false
      }
    },
    selectPostal (item) {
      this.post.ville = item.ville
      this.post.code_postal = item.code_postal
    },
    selectPostalInternet (item) {
      this.post.ville_contact_a_afficher = item.ville
      this.post.code_postal_contact_a_afficher = item.code_postal
    },
    selectPostalProprietaire (item) {
      this.post.proprietaire_ville = item.ville
      this.post.proprietaire_code_postal = item.code_postal
    },
    selectPostalReel (item) {
      this.post.ville_reelle = item.ville
      this.post.code_postal_reel = item.code_postal
    },
    selectTypeOffreComponent () {
      if (this.post.typeOffre) {
        const component = 'PostEditImmoOffer' + this.post.typeOffre
        if (this.$options.components[component]) {
          return component
        } else {
          this.tabs[1].disabled = true
        }
      }
      return null
    },
    getChoices (code) {
      if (!this.ddList) return []
      const dd = this.ddList.find(x => x.code === code.toUpperCase())
      if (dd) {
        return dd.values
      }
      return []
    },
    chargerPays () {
      if (!this.post.pays) {
        if (this.sitimmoUser.pays) {
          this.paysValue = this.sitimmoUser.pays
        } else {
          this.paysValue = 'France'
        }
      } else {
        this.paysValue = this.post.pays
      }
      if (this.paysValue === 'Maurice' || this.paysValue === 'Mauritius' || this.paysValue === 'Mauricio') {
        this.isPaysMaurice = true
      }
    },
    ddListUpdated (ddList) {
      if (this.ddList.length > 0) {
        ddList.forEach(function (item) {
          if (!_find(this.ddList, { code: item.code })) {
            this.ddList.push(item)
          }
        }, this)
      }
    },
    aDesactiver () {
      if (this.create) {
        this.desactiverChamp = false
        this.SET_MEDIA_UPLOAD_DISABLED(false)
      } else if (this.sitimmoUser.saisit_en_ligne_et_flux && this.$route.query.saisie !== 'SAISIE_IMMO') {
        this.desactiverChamp = true
        this.SET_MEDIA_UPLOAD_DISABLED(true)
      } else {
        this.desactiverChamp = false
        this.SET_MEDIA_UPLOAD_DISABLED(false)
      }
      if (this.post.emission && this.post.emission.picturesManagedBySeize && this.post.emission.picturesManagedBySeize === true) {
        this.SET_MEDIA_UPLOAD_DISABLED(false)
      }
    },
    aDesactiverTexte () {
      if (this.create) {
        this.desactiverTexte = false
        this.desactiverTitre = false
      } else if (this.sitimmoUser.saisit_en_ligne_et_flux &&
          (this.$route.query.saisie !== 'SAISIE_IMMO') &&
          (!this.sitimmoUser.betaTesteur) &&
          (!this.sitimmoUser.id == 314514)) {
        this.desactiverTexte = true
        this.desactiverTitre = true
      } else {
        this.desactiverTexte = false
        this.desactiverTitre = false
      }
    },
    TVA (taux) {
      if (taux == 'TVA_7' && this.post.TVA_7 == 'oui') {
        this.post.taux_tva = 7
        this.post.TVA_55 = null
      } else if (taux == 'TVA_55' && this.post.TVA_55 == 'oui') {
        this.post.taux_tva = 5.5
        this.post.TVA_7 = null
      } else {
        this.post.taux_tva = null
        this.post.TVA_7 = null
        this.post.TVA_55 = null
      }
    },
    chargementValue () {
      if (!this.create && this.chargementDonnees) {
        if (this.post.ville_reelle || this.post.ville) {
          if (this.post && !this.post.ville_reelle && this.post.ville) {
            this.post.ville_reelle = this.post.ville
          }
          if (this.post && !this.post.code_postal_reel && this.post.code_postal) {
            this.post.code_postal_reel = this.post.code_postal
          }
          this.chargementDonnees = false
        }
      }
    },
    deviseSelect (value) {
      this.valueDevise = value
      this.$store.commit('donnees/SET_DEVISE', this.post.devise_iso_4217)
      return value
    },
    changeLoyerCC () {
      if (this.post.loyer_est_cc === 'oui' && this.post.charges_locatives) {
        this.post.loyer_mensuel = this.post.loyer_mensuel + this.post.charges_locatives
        this.post.loyer_de_base = this.post.loyer_mensuel
        this.post.charges_locatives = 0
      }
    },
    checkJardin () {
      if (this.post.avec_jardin === 'non') {
        delete this.post.type_jardin
      }
    }
  },
  computed: {
    ...mapState('posts', ['filter', 'results']),
    ...mapGetters(['getCountries']),
    ...mapGetters('postEditImmo', ['mediaUploadDisabled']),
    user () {
      return this.$store.getters.getUser
    },
    sitimmoUser () {
      return this.$store.getters.getSitimmoUser
    },
    sitimmoLogin () {
      return this.sitimmoUser.login
    },
    isPromoteur () {
      return this.sitimmoUser.metier === 'PROMOTEUR'
    },
    isBailleurSocial () {
      return this.sitimmoUser.metier === 'BAILLEUR_SOCIAL'
    },
    isCmiste () {
      return this.sitimmoUser.metier === 'CMI'
    },
    isUSH () {
      return this.user.isUSH
    },
    isIncludesAnnonceursVisites () {
      return (this.sitimmoUser.univers === 'IMMO') && this.sitimmoUser.optionVisite
    },
    isChecked () {
      const val = this.valueChange
      this.valueChange = ''
      return this.checkedList[val]
    },
    valueChangeLot () {
      const val = this.valueChange
      this.valueChange = ''
      return val
    },
    getDevise () {
      return this.$store.getters['donnees/getDevise']
    },
    isARLOGIS () {
      return this.sitimmoUser.reseau === 'ARLOGIS'
    }
  },
  async beforeMount () {
    if (this.isPromoteur || this.isBailleurSocial) {
      if (!this.filter.annonceParente && (this.isPromoteur || (this.isBailleurSocial && this.filter.creationProgramme))) {
        this.post.typeOffre = 'G'
        this.isProgramBailleur = true
        this.tabs = this.tabsProgramme
      } else if (!this.filter.annonceParente && this.isBailleurSocial && !this.filter.creationProgramme) {

      } else {
        this.post.typeOffre = 'G'
        this.tabs = this.tabsLot
        const annonceParente = await getPostById(this.filter.annonceParente)
        if (annonceParente.type == 'error') {
          this.loading = false
          return false
        }
        this.nomProgram = annonceParente.programme_neuf_nom
        this.post.annonce_parente_reference = annonceParente.reference
        this.post.annonce_parente_type_objet = annonceParente.typeObjet
        this.setAdManagerChanged(true)
      }
    }
    this.selectTypeObjetComponent()
    this.selectTypeOffreComponent()
    if (!this.isCmiste && !this.isPromoteur) {
      this.tabs = this.tabs.filter(function (item) {
        return item.name != 'mentions_legales'
      })
    }
    if (this.isCmiste && this.post.id && this.post.typeOffre == 1200) {
      this.tabs = this.tabsModele
    }
    if (!this.filter.annonceParente && this.isBailleurSocial && (this.post.typeOffre >= 3000 && this.post.typeOffre < 4000)) {
      this.isProgramBailleur = true
    }
    if (this.post.pays === 'Maurice' || this.post.pays === 'Mauritius' || this.post.pays === 'Mauricio') {
      this.isPaysMaurice = true
    } else {
      this.isPaysMaurice = false
    }
    this.setTabs(this.tabs)
    this.chargerPays()
    let codes = [
      'type_cuisine',
      'eau_chaude_distribution',
      'chauffage_energie',
      'chauffage_type',
      'vitrages',
      'type_stationnement',
      'type_jardin',
      'grenier',
      'revetement_sol_principal',
      'exposition',
      'environnement',
      'standing',
      'dpe_etiquette_conso',
      'dpe_etiquette_ges',
      'residence_type',
      'type_voie',
      'devise_iso_4217',
      'mitoyennete',
      'type_construction',
      'type_plafond_ressources',
      'schema_legal_mus',
      'piscine_type',
      'obligation_debroussaillement',
      'referentiel_activites_commerce',
      'type_document_1',
      'disponibilite_lot'
    ]
    codes = codes.map(function (x) {
      return x.toUpperCase()
    })
    this.ddList = await getDefinitionDonneeListeeByCode({ codes: codes })
    this.disableChampsLocSaisonniere()

    if (this.isIncludesAnnonceursVisites) {
      const ongletParametre = { name: 'parametres', title: this.$t('posts.edit.tabParametres') }
      this.tabs.push(ongletParametre)
    }
    this.setAdManagerChanged(false)
  },
  async mounted () {
    // Cas d'un lot en création d'annonce
    if (this.filter.annonceParente && (!this.post.id && !this.$route.params.id) && !this.isCmiste) {
      this.parent = await getPostById(this.filter.annonceParente)
      if (this.parent.type === 'error') {
        this.loading = false
        return false
      }
      this.post = duplicateFromParent(this.parent, this.post)
      this.chargerPays()
      this.checkedList = checkedPromoteurLot(this.post, this.checkedList)
      console.log(this.checkedList)
    }
    if (!this.post.devise_iso_4217) {
      this.post.devise_iso_4217 = 'EUR'
    }
    this.aDesactiver()
    this.aDesactiverTexte()
    if (this.isCmiste && this.post.id != null) {
      this.tabs[1].disabled = false
      this.tabs[2].disabled = false
    }
  }
}
</script>

<style>
.el-option__label::first-letter {
  text-transform: uppercase;
}

.el-radio__label::first-letter {
  text-transform: uppercase;
}

.el-checkbox__label::first-letter {
  text-transform: uppercase;
}

.red {
  color: red;
}
</style>
